<template>
  <ListView
    modelName="StockBalance"
    perm="stock.menu_stock_balance"
    svg="icon_side_stock"
    :items.sync="items"
    :params.sync="params"
    title="menu_stock_balance"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="StockBalance"
    :gridCaptions="gridConfig.gridCaptions"
    :gridWidths="gridConfig.gridWidths"
    :importQuery="null"
    :exportQuery="exportQuery"
    class="stock_transfer"
    borderColor="#61AA72"
    backColor="#EAFFEF"
    :comparer="(a,b)=>a.id == b.id"
    :popup="popup"                
    :beforeCustomExport="validateNotAggregated"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }">{{ item.closingDate | dateYM }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }">{{ item.stockKey.segmentId | segment }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.stockKey.warehouse ? item.stockKey.warehouse.name : '' }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.stockKey.projectItem ? item.stockKey.projectItem.name : '' }}</GridItem>    
    <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.stockKey.commodity ? item.stockKey.commodity.code : '' }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.stockKey.commodity ? item.stockKey.commodity.name : '端数調整口' }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.stockKey.commodity ? item.stockKey.commodity.model : '' }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.stockKey.skuId ? item.stockKey.sku.name : '' }}</GridItem>

    <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.beginningTotalStockQuantity | numeric(item.quantityScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.beginningTotalStockAmount | amount  }}</GridItem>
    <!-- <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.migrationQuantity }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.migrationAmount }}</GridItem> -->
    <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.purchaseQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }" :right="true">{{ item.purchaseAmount | amount  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }" :right="true">{{ item.purchaseChargeAmount | amount }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item}" :right="true">{{ item.totalTransferQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item}" :right="true">{{ item.totalTransferAmount | amount  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }" :right="true">{{ item.salesQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }" :right="true">{{ item.salesAmount | amount  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }" :right="true">{{ item.salesChargeAmount | amount  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[18]" slot-scope="{ item }" :right="true">{{ item.withDrawAmount  | amount }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }" :right="true">{{ item.differentialQuantityActual | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[20]" slot-scope="{ item }" :right="true">{{ item.quantityLossAmount | amount  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }" :right="true">{{ item.totalStockQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[22]" slot-scope="{ item }" :right="true">{{ item.stockQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }" :right="true">{{ item.totalConsignmentQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[24]" slot-scope="{ item }" :right="true">{{ item.stockPrice | numeric(item.priceScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[25]" slot-scope="{ item }" :right="true">{{ item.totalStockAmount | amount  }}</GridItem>
    <!-- <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }">{{ item.totalUndeliveredQuantity }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[20]" slot-scope="{ item }">{{ item.totalUndeliveredAmount }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }">{{ item.totalConsignmentQuantity }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[22]" slot-scope="{ item }">{{ item.totalConsignmentAmount }}</GridItem> -->
    <!-- <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }">{{ item.totalSchedulePurchaseQuantity }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[24]" slot-scope="{ item }">{{ item.totalScheduleSalesQuantity }}</GridItem> -->
    <!-- <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }">{{ item.scheduleQuantity }}</GridItem> -->

    <!-- <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }">{{ item.stockKey.deliveryId }}</GridItem> -->

    <GridItem :slot="gridConfig.gridSlots[26]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText1 : item.stockKey.reserveText1) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[27]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText2 : item.stockKey.reserveText2) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[28]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText3 : item.stockKey.reserveText3) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[29]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText4 : item.stockKey.reserveText4) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[30]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText5 : item.stockKey.reserveText5) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[31]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveText6 : item.stockKey.reserveText6) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[32]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveMemo1 : item.stockKey.reserveMemo1) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[33]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveMemo2 : item.stockKey.reserveMemo2) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[34]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveMemo3 : item.stockKey.reserveMemo3) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[35]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveDate1 : item.stockKey.reserveDate1) | date  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[36]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveDate2 : item.stockKey.reserveDate2) | date }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[37]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveDate3 : item.stockKey.reserveDate3) | date }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[38]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveList1 : item.stockKey.reserveList1) | category_41 }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[39]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveList2 : item.stockKey.reserveList2) | category_42 }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[40]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ?  item.stockKey.commodity.reserveList3 : item.stockKey.reserveList3) | category_43 }}</GridItem>

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :edit="true" :copy="false" :del="false" :beforeReportGenerate="validateNotAggregated" :beforeExport="validateNotAggregated">
        <!-- <ListViewMenu title="在庫数量詳細" @click="showStockBalanceQuantityDialog" /> -->
        <!-- <ListViewMenu title="在庫金額詳細" @click="showStockBalanceAmountDialog" /> -->
        <!-- <ListViewMenu title="単価詳細" @click="showStockPricingDetailDialog" /> -->
        <ListViewMenu title="在庫移動" @click="showStockRelocationDialog" />
        <ListViewMenu title="セット組立" @click="showStockAssemblyDialog" />
        <ListViewMenu title="セット分解" @click="showStockDivideDialog" />
        <ListViewMenu title="在庫振替" @click="showPriviousStockTransferDialog" />
        <ListViewMenu title="棚卸処理" @click="showStockTakingDialog" />
        <ListViewMenu title="諸掛按分処理" @click="showChargeAllocationDialog" />
        <ListViewMenu slot="export"  icon="cloud_download" title="エクスポート(実地棚卸)" @click="listView.onCustomExport(stockTakingExportQuery)" />
        <ListViewMenu slot="export"  icon="cloud_download" title="エクスポート(在庫移行)" @click="listView.onCustomExport(migrationExportQuery)" />
        <ListViewMenu slot="import"  icon="cloud_upload" title="インポート(実地棚卸)" @click="listView.onCustomImport(stockTakingImportQuery)" :perm="listView.perm + '.import'" />
        <ListViewMenu slot="import"  icon="cloud_upload" title="インポート(在庫移行)" @click="listView.onCustomImport(migrationImportQuery)" :perm="listView.perm + '.import'"  />
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="searchTabs" :favoriteVisible="!popup">
        <Calendar title="限月" :value.sync="params.closingDate" :month="true" @changed="handler" :enabled="!isStockPopup"/>
        <ComboBox title="集計" :value.sync="params.aggregationType" list="stockBalanceAggregationTypes" :showDefault="false" @changed="handler" :enabled="!isStockPopup"/>
        <ComboBox title="案件区分" :value.sync="params.excludeProject" list="excludeProjectFlags" :nullValue="false" @changed="handler" :showDefault="sbqFooterQuantityScale" :enabled="!isStockPopup"/>        
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler" :enabled="!isStockPopup"/>          
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" :enabled="!isStockPopup"/>
        <AtcCounterpart title="倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" :enabled="!isStockPopup"/>
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />
        <FilterBox title="コード･名称･型番" :value.sync="params.codeNameModel"  @click="handler"  tooltip="商品マスタのコード、名称、型番のいずれかに部分一致する商品を検索することができます。" />
        <ComboBox title="商品区分1" :value.sync="params.commodityCategory1" list="category_11" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分2" :value.sync="params.commodityCategory2" list="category_12" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分3" :value.sync="params.commodityCategory3" list="category_13" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分4" :value.sync="params.commodityCategory4" list="category_14" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分5" :value.sync="params.commodityCategory5" list="category_15" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分6" :value.sync="params.commodityCategory6" list="category_16" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <FilterBox slot="tab1" title="reserve_text1" :value.sync="params.reserveText1" @click="handler"   v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText1)" />
        <FilterBox slot="tab1" title="reserve_text2" :value.sync="params.reserveText2" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText2)"/>
        <FilterBox slot="tab1" title="reserve_text3" :value.sync="params.reserveText3" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText3)"/>
        <FilterBox slot="tab1" title="reserve_text4" :value.sync="params.reserveText4" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText4)"/>
        <FilterBox slot="tab1" title="reserve_text5" :value.sync="params.reserveText5" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText5)"/>
        <FilterBox slot="tab1" title="reserve_text6" :value.sync="params.reserveText6" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText6)"/>
        <FilterBox slot="tab1" title="reserve_memo1" :value.sync="params.reserveMemo1" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <FilterBox slot="tab1" title="reserve_memo2" :value.sync="params.reserveMemo2" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <FilterBox slot="tab1" title="reserve_memo3" :value.sync="params.reserveMemo3" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar slot="tab1" title="reserve_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar slot="tab1" title="reserve_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <ComboBox slot="tab1" title="reserve_list1" :value.sync="params.reserveList1" list="category_41" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList1)"/>
        <ComboBox slot="tab1" title="reserve_list2" :value.sync="params.reserveList2" list="category_42" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList2)"/>
        <ComboBox slot="tab1" title="reserve_list3" :value.sync="params.reserveList3" list="category_43" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList3)"/>
        <AutoComplete title="構成品抽出" :value.sync="params.assembly" query="AssemblyMasterQuery" @changed="handler" tooltip="セット組立を行う場合にセット品を指定して構成品を抽出します。"/>
      </Search>
    </template>
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','在庫数量','在庫金額','予備項目']" :spEditVisible="false">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu">
          <SplitButton class="button" @click="showStockBalanceQuantityDialog" caption="在庫数量詳細"  icon="arrow_downward">
          <Button class="button" @click="showStockBalanceAmountDialog" caption="在庫金額詳細"  icon="arrow_downward"/>
          <Button class="button" @click="showStockPricingDetailDialog" caption="在庫単価詳細"  icon="arrow_downward"/>
          </SplitButton>
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <Calendar title="限月" :value="item.closingDate" :editor="editor" :enabled="false" tooltip="表示されている在庫の限月です。表示されている在庫情報は、限月末日の断面での情報です。検索部より限月を変更できます。"/>
              <AtcSegment title="部門" :value="item.stockKey.segment" :editor="editor" :enabled="false" tooltip="在庫が所属している部門です。同一商品でも部門・倉庫ごとに管理が異なります。" />
              <AtcCounterpart title="倉庫" :value="item.stockKey.warehouse" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="在庫を持っている倉庫です。同一商品でも部門・倉庫ごとに管理が異なります。" />
              <TextBox title="商品コード" :value="item.stockKey.commodity.code" :editor="editor" :enabled="false" tooltip="在庫商品のコードです。【商品マスタ】で登録されている【コード】が表示されます。" />
              <AtcCommodity title="商品" :value="item.stockKey.commodity" :editor="editor" :enabled="false" tooltip="在庫商品の名称です。入荷時の【商品名称】ではなく、【商品マスタ】で登録されている【商品名称】が表示されます。" />
              <TextBox title="型番" :value="item.stockKey.commodity.model" :editor="editor" :enabled="false" tooltip="在庫商品の型番です。【商品マスタ】で登録されている【型番】が表示されます。" />
              <AtcSKU title="SKU" :value="item.stockKey.sku" :editor="editor" :commodity="item.stockKey.commodity" :enabled="false" tooltip="在庫商品のSKU情報です。同一商品でもSKUにより別の在庫として扱われます。" />
              <NumericBox title="在庫単価" :value="item.stockPrice" :editor="editor" :enabled="false" :decimals="item.priceScale" tooltip="在庫単価です。在庫単価の計算法は【部門マスタ】の【在庫単価計算方法】で変更できます。" />
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <AtcProjectItem title="案件" :value.sync="item.stockKey.projectItem" :editor="editor"  :enabled="false"  tooltip="受注伝票・発注伝票で指定した案件が表示されます。"/>
              <TextBox title="入荷明細番号" :value="item.deliveryItemNo" :editor="editor" :enabled="false" tooltip="その在庫を入荷した入荷明細番号です。【直送】の場合や、部門の【在庫単価計算方法】が【個別法】の場合に表示されます。" />


            </template>
          </EditPanel>
        </template>
        <template slot="tab1" slot-scope="{ item, editor }">
          <EditPanel>
            <template slot="left">

              <div class="cx_controls">
                  <NumericBox title="繰越在庫数量" :value="item.beginningTotalStockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="前月から繰り越された在庫数です。前月の在庫数の増減により変更されます。" />
               　<NumericBox title="(庫内数量)" :value="item.beginningStockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="【繰越在庫数量】から【繰越積送数量】を引いた、前月末の倉庫内数量です。" />

                </div>
              <!-- <div class="cx_controls">
                  <span></span>
                   <NumericBox title="(庫内数量)" :value="item.beginningStockQuantity" :editor="editor" :enabled="false" decimals="3" />
              </div> -->
              <NumericBox title="仕入数量" :value="item.purchaseQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="入荷から仕入計上まで行われている数量です。" />
              <NumericBox title="振替数量" :value="item.totalTransferQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="在庫移動や、在庫振替がされた数量です。セット品組み立てや分解の数量も加算されます。"/>
              <NumericBox title="移行数量" :value="item.migrationQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="在庫移行がされた数量です。在庫移行を行うと、移行した数量で上書きされます。"/>
              <div class="cx_controls">
                <NumericBox title="売上数量" :value="item.salesQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="売上として計上された数量です。請求が確定（請求締処理）された際に加算されます。" />

                </div>
              <NumericBox title="減耗数量" :value="item.differentialQuantityActual" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="棚卸処理で発生した減耗数量です。システム上の在庫数と棚卸の結果である実在庫の差により発生します。" />
              <div class="cx_controls">
                <NumericBox title="在庫数量" :value="item.totalStockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="表示されている限月での在庫数量です。【積送数量】を含みます。" />
                <NumericBox title="(庫内数量)" :value="item.stockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="表示されている限月での在庫数量です。【積送数量】を含みません。" />

                </div>
              <!-- <div class="cx_controls">
                  <span></span>
                <NumericBox title="(庫内数量)" :value="item.stockQuantity" :editor="editor" :enabled="false" decimals="3" />
              </div> -->
            </template>
            <template slot="right">
              <NumericBox title="繰越積送数量" :value="item.beginningConsignmentQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="前月から繰り越された【積送数量】です。前月に出荷が確定していて計上されていない数量になります。" />
              <NumericBox title="積送計上数量" :value="item.consignmentQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="限月中に出荷確定され、請求締されていない数量です。"/>
              <NumericBox title="積送数量" :value="item.totalConsignmentQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="【繰越積送数量】と【積送計上数量】の合計です。" />
              <NumericBox title="繰越未着数量" :value="item.beginningUndeliveredQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="前月から繰り越された【未着数量】です。前月に入荷作成がされていて仕入計上されていない数量になります。" />
              <NumericBox title="未着計上数量" :value="item.undeliveredQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="限月中の【未着数量】です。入荷日が限月中で入荷作成がされていて仕入計上されていない数量になります。" />
              <NumericBox title="未着数量" :value="item.totalUndeliveredQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="未着品として入荷予定となっている数量です。" />
              <NumericBox title="繰越未確定在庫数量" :value="item.beginningScheduleQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="繰越された、前月の【未確定在庫数量】です。" />
              <div class="cx_controls">
              <NumericBox title="未確定入荷数量" :value="item.schedulePurchaseQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="月内の入荷登録がされていて、計上がされていない数量です。在庫として引当可能です。" />
              <NumericBox title="未確定出荷数量" :value="item.scheduleSalesQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="月内の出荷登録がされていて、計上がされていない数量です。" />
              </div>
              <NumericBox title="未確定在庫数量" :value="item.scheduleQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="【未確定入荷数量】 - 【未確定出荷数量】です。" />
            </template>
          </EditPanel>
        </template>
        <template slot="tab2" slot-scope="{ item, editor }">
          <EditPanel>
            <template slot="left">
              <div class="cx_controls">
              　<NumericBox title="繰越在庫金額" :value="item.beginningTotalStockAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="前月から繰り越された【在庫金額】です。" />
                <NumericBox title="(庫内金額)" :value="item.beginningStockAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="【繰越在庫金額】から【繰越積送金額】を引いた金額です。"  />
              </div>
              <!-- <div class="cx_controls">


                </div>               -->
              <NumericBox title="仕入金額" :value="item.purchaseAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="入荷から仕入計上まで行われている金額です。" />
              <NumericBox title="仕入諸掛金額" :value="item.purchaseChargeAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="按分された仕入諸掛の合計金額です。在庫に按分された諸掛も含まれます。" />
              <NumericBox title="振替金額" :value="item.totalTransferAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="在庫移動や、在庫振替がされた金額です。セット品組み立てや分解の金額も含まれます。" />
              <NumericBox title="移行金額" :value="item.migrationAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="在庫移行がされた金額です。在庫移行を行うと、移行した金額で上書きされます。"/>
              <NumericBox title="払出金額" :value="item.withDrawAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="限月中に払出がされた金額です。出荷として払出された数量×単価になります。" />
              <NumericBox title="減耗金額" :value="item.quantityLossAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="棚卸処理で発生した減耗金額です。システム上の在庫数と棚卸の結果である実在庫の差とその在庫単価により発生します。" />
              <div class="cx_controls">
              <NumericBox title="在庫金額" :value="item.totalStockAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="【仕入金額】と【払出金額】を積み上げた在庫金額です。【積送金額】を含みます。"  />
              <NumericBox title="(庫内金額)" :value="item.stockAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="【仕入金額】と【払出金額】を積み上げた在庫金額です。【積送金額】を含みません。" />
              </div>
              <div class="cx_controls">

              </div>
            </template>
            <template slot="right">
              <NumericBox title="繰越積送金額" :value="item.beginningConsignmentAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="前月から繰り越された積送金額です。前月に出荷が確定していて計上されていない金額になります。" />
              <NumericBox title="積送金額" :value="item.totalConsignmentAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="積送中の金額です。積送数量と単価により決定されます。" />

              <NumericBox title="繰越未着金額" :value="item.beginningUndeliveredAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="前月から繰り越された未着金額です。前月に入荷がされていて仕入計上されていない金額になります。" />
              <NumericBox title="未着計上金額" :value="item.undeliveredAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="限月中の未着金額です。入荷日が限月中に入荷されていて仕入計上されていない金額になります。"  />
              <NumericBox title="未着金額" :value="item.totalUndeliveredAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="未着品として入荷予定となっており、既に計上済みの数量です。" />

              <NumericBox title="売上金額" :value="item.salesAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="売上として計上された金額です。請求が確定（請求締処理）された際に加算されます。" />
              <NumericBox title="売上諸掛金額" :value="item.salesChargeAmount" :editor="editor" :enabled="false" :decimals="$api.systemCurrencyPrecision" tooltip="按分された売上諸掛の合計金額です。在庫に按分された諸掛は含まれません。" />



              <!-- <NumericBox title="繰越積送金額" :value="item.beginningConsignmentAmount" :editor="editor" :enabled="false" decimals="2" /> -->
              <!-- <NumericBox title="積送出荷金額" :value="item.consignmentAmount" :editor="editor" :enabled="false" decimals="2" /> -->


            </template>
          </EditPanel>
        </template>
        <template slot="tab3" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item.stockKey" :editor="editor" :enabled="false" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.ReadOnly"  :orderMemo="visibleTypes.None" :deliveryMemo="visibleTypes.None" :commodity="item.stockKey.commodity" />
        </template>
      </Editor>
    </template>         
    <template slot="modal" slot-scope="{ listView }">     
      <!-- 在庫数量詳細ダイアログ -->
      <ListDialog ref="stockBalanceQuantityDialog" title="在庫数量詳細" modelName="StockBalanceJournal"  class="cx_stock_dialog"
        :captions="[ '発生日', '伝票区分', '伝票明細番号','移行数量', '未着計上', '仕入数量', '振替数量', '積送計上', '売上数量', '減耗数量',   '庫内数量*','積送数量*', '未着数量*', '予定入荷数量', '予定出荷数量','未確定在庫数量*',]"
        :widths="[120, 120, 150,150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150]"
        :showAdd="false" :showRemove="false" :height="235" :width="1000">
        <!-- 在庫数量詳細ダイアログ 一覧項目 -->
        <TextBox slot="col0" slot-scope="{ item }" :value="item.balanceAccrualDate | date" :enabled="false" />
        <TextBox slot="col1" slot-scope="{ item }" :value="item.voucherType | voucherTypes" :enabled="false" />
        <TextBox slot="col2" slot-scope="{ item }" :value="item.itemNo" :enabled="false" />
        <NumericBox slot="col3" slot-scope="{ item }" :value="item.migrationQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col4" slot-scope="{ item }" :value="item.undeliveredQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col5" slot-scope="{ item }" :value="item.purchaseQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col6" slot-scope="{ item }" :value="item.transferQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col7" slot-scope="{ item }" :value="item.consignmentQuantity" :enabled="false" :decimals="sbqFooterQuantityScale"  />
        <NumericBox slot="col8" slot-scope="{ item }" :value="item.salesQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col9" slot-scope="{ item }" :value="item.differentialQuantityActual" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col10" slot-scope="{ item }" :value="item.stockQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col11" slot-scope="{ item }" :value="item.totalConsignmentQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col12" slot-scope="{ item }" :value="item.totalUndeliveredQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col13" slot-scope="{ item }" :value="item.schedulePurchaseQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col14" slot-scope="{ item }" :value="item.scheduleSalesQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <NumericBox slot="col15" slot-scope="{ item }" :value="item.totalScheduleStockQuantity" :enabled="false" :decimals="sbqFooterQuantityScale" />
        <template slot="footer" slot-scope="{ editor }">
          <EditPanel>
            <!-- 在庫数量詳細ダイアログ フッタ項目 -->
            <template slot="left">
              <NumericBox title="移行数量合計" :value="sbqFooterMigrationQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に行われた在庫移行の数量です。" />
              <NumericBox title="未着計上合計" :value="sbqFooterUndeliveredQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に未着品として登録され、計上済の数量の合計です。"/>
              <NumericBox title="仕入数量合計" :value="sbqFooterPurchaseQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale"  tooltip="限月中に入荷・仕入計上された数量の合計です。" />
              <NumericBox title="振替数量合計" :value="sbqFooterTransferQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale"  tooltip="限月中に行われた在庫移動、在庫振替の数量の合計です。出庫は減算され、入庫は加算されます。"/>
              <NumericBox title="積送計上合計" :value="sbqFooterConsignmentQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に出荷確定され、請求締されていない数量です。" />
              <NumericBox title="売上数量合計" :value="sbqFooterSalesQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に売上として計上された数量です。請求が確定（請求締処理）された際に加算されます。" />
              <NumericBox title="減耗数量合計" :value="sbqFooterDifferentialQuantityActual" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に棚卸処理で発生した減耗数量です。システム上の在庫数と棚卸の結果である実在庫の差により発生します。" />

              <!-- <NumericBox title="庫内数量合計*" :value="sbqFooterStockQuantity" :editor="editor" :enabled="false" decimals="3" /> -->
              <!-- <NumericBox title="積送数量合計*" :value="sbqFooterTotalConsignmentQuantity" :editor="editor" :enabled="false" decimals="3"/> -->
              <!-- <NumericBox title="在庫数量合計*" :value="sbqFooterTotalStockQuantity" :editor="editor" :enabled="false" decimals="3"/> -->
            </template>
            <template slot="right">

              <!-- <NumericBox title="未着数量合計*" :value="sbqFooterTotalUndeliveredQuantity" :editor="editor" :enabled="false" decimals="3" /> -->

              <NumericBox title="予定入荷数量合計" :value="sbqFooterSchedulePurchaseQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に入荷が予定されている数量の合計です。" />
              <NumericBox title="予定出荷数量合計" :value="sbqFooterScheduleSalesQuantity" :editor="editor" :enabled="false" :decimals="sbqFooterQuantityScale" tooltip="限月中に出荷が予定されている数量の合計です。" />
              <!-- <NumericBox title="未確定在庫数量合計*" :value="sbqFooterScheduleStockQuantity" :editor="editor" :enabled="false" decimals="3" /> -->
              <span class="cx_label">*は翌月に繰越される項目です。</span>
            </template>
          </EditPanel>
        </template>
      </ListDialog>
     <!-- 在庫金額詳細ダイアログ -->
      <ListDialog ref="stockBalanceAmountDialog" title="在庫金額詳細" modelName="StockBalanceJournal" class="cx_stock_dialog"
        :captions="[ '発生日', '伝票区分', '伝票明細番号','移行金額', '未着計上', '仕入金額', '仕入諸掛', '振替金額', '払出金額', '売上金額', '売上諸掛', '減耗金額', '在庫金額*',  '未着金額*']"
        :widths="[100, 100, 120,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100]"
        :showAdd="false" :showRemove="false" :height="235" :width="1000">
        <!-- 在庫数量詳細ダイアログ 一覧項目 -->
        <TextBox slot="col0" slot-scope="{ item }" :value="item.balanceAccrualDate | date" :enabled="false" />
        <TextBox slot="col1" slot-scope="{ item }" :value="item.voucherType | voucherTypes" :enabled="false" />
        <TextBox slot="col2" slot-scope="{ item }" :value="item.itemNo" :enabled="false" />
        <NumericBox slot="col3" slot-scope="{ item }" :value="item.migrationAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col4" slot-scope="{ item }" :value="item.undeliveredAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col5" slot-scope="{ item }" :value="item.purchaseAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col6" slot-scope="{ item }" :value="item.purchaseChargeAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col7" slot-scope="{ item }" :value="item.transferAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <!-- <TextBox slot="col7" slot-scope="{ item }" :value="item.consignmentAmount" :enabled="false" /> -->
        <NumericBox slot="col8" slot-scope="{ item }" :value="item.withDrawAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col9" slot-scope="{ item }" :value="item.salesAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col10" slot-scope="{ item }" :value="item.salesChargeAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col11" slot-scope="{ item }" :value="item.quantityLossAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col12" slot-scope="{ item }" :value="item.totalStockAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <NumericBox slot="col13" slot-scope="{ item }" :value="item.totalUndeliveredAmount" :enabled="false"  :decimals="sbaFooterAmountScale"/>
        <!-- <TextBox slot="col14" slot-scope="{ item }" :value="item.totalConsignmentAmount" :enabled="false" /> -->
        <template slot="footer" slot-scope="{ editor }">
          <EditPanel>
            <!-- 在庫金額詳細ダイアログ フッタ項目 -->
            <template slot="left">
              <NumericBox title="仕入金額合計" :value="sbaFooterPurchaseAmount" :editor="editor" :enabled="false" :decimals="sbaFooterAmountScale" tooltip="限月中に入荷から仕入計上まで行われている金額です。" />
              <NumericBox title="仕入諸掛合計" :value="sbaFooterPurchaseChargeAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale" tooltip="限月中に按分された仕入諸掛の合計金額です。在庫に按分された諸掛も含まれます。" />
              <NumericBox title="振替金額合計" :value="sbaFooterTransferAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale" tooltip="限月中に在庫移動や在庫振替された金額の合計です。出庫は減算され、入庫は加算されます。" />
              <!-- <NumericBox title="積送計上合計" :value="sbaFooterConsignmentAmount" :editor="editor" :enabled="false" decimals="2"/> -->
              <NumericBox title="払出金額合計" :value="sbaFooterWithDrawAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale" tooltip="限月中に払出がされた金額です。出荷として払出された数量×単価になります。" />
              <NumericBox title="減耗金額合計" :value="sbaFooterQuantityLossAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale" tooltip="限月中に棚卸処理で発生した減耗金額です。システム上の在庫数と棚卸の結果である実在庫の差とその在庫単価により発生します。" />
              <!-- <NumericBox title="在庫金額合計*" :value="sbaFooterTotalStockAmount" :editor="editor" :enabled="false" decimals="2" />        -->
              <!-- <NumericBox title="(庫内金額)" :value="sbaFooterStockAmount" :editor="editor" :enabled="false" decimals="2" />               -->
              <!-- <NumericBox title="(積送金額)" :value="sbaFooterTotalConsignmentAmount" :editor="editor" :enabled="false" decimals="2"/> -->
            </template>
            <template slot="right">
              <NumericBox title="移行金額合計" :value="sbaFooterMigrationAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale"  tooltip="限月中に在庫移行がされた金額です。在庫移行を行うと、移行した金額で上書きされます。" />
              <NumericBox title="未着計上合計" :value="sbaFooterUndeliveredAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale"  tooltip="限月中の未着金額です。入荷日が限月中に入荷されていて仕入計上されていない金額になります。" />
              <!-- <NumericBox title="未着金額合計*" :value="sbaFooterTotalUndeliveredAmount" :editor="editor" :enabled="false" decimals="2" /> -->

              <NumericBox title="売上金額合計" :value="sbaFooterSalesAmount" :editor="editor" :enabled="false"  :decimals="sbaFooterAmountScale" tooltip="限月中に売上として計上された金額です。請求が確定（請求締処理）された際に加算されます。" />
              <NumericBox title="売上諸掛合計" :value="sbaFooterSalesChargeAmount" :editor="editor" :enabled="false" :decimals="sbaFooterAmountScale" tooltip="限月中に按分された売上諸掛の合計金額です。在庫に按分された諸掛は含まれません。" />

            </template>
          </EditPanel>
        </template>
      </ListDialog>
      <!-- 単価詳細ダイアログ -->
      <ListDialog ref="showStockPricingDetailDialog" title="単価詳細" modelName="StockBalanceJournal" class="cx_stock_dialog"
        :captions="spdListCaptions"
        :widths="spdListWidths"
        :showAdd="false" :showRemove="false" :height="235" :width="1000">
        <!-- 単価詳細ダイアログ 一覧項目 -->
        <TextBox :slot="spdListSlots[0]" slot-scope="{ item }" :value="item.pricingAccrualDate | date" :enabled="false" />
        <TextBox :slot="spdListSlots[1]" slot-scope="{ item }" :value="item.voucherType | voucherTypes" :enabled="false" />
        <TextBox :slot="spdListSlots[2]" slot-scope="{ item }" :value="item.itemNo" :enabled="false" />
        <NumericBox :slot="spdListSlots[3]" slot-scope="{ item }" :value="item.receiptQuantity" :enabled="false" :decimals="spdQuantityScale" />
        <NumericBox :slot="spdListSlots[4]" slot-scope="{ item }" :value="item.receiptPrice" :enabled="false" :decimals="spdPriceScale"/>
        <NumericBox :slot="spdListSlots[5]" slot-scope="{ item }" :value="item.receiptAmount" :enabled="false" :decimals="spdAmountScale" />
        <NumericBox :slot="spdListSlots[6]" slot-scope="{ item }" :value="item.withDrawQuantity" :enabled="false" :decimals="spdQuantityScale" />
        <NumericBox :slot="spdListSlots[7]" slot-scope="{ item }" :value="item.withDrawPrice" :enabled="false" :decimals="spdPriceScale" />
        <NumericBox :slot="spdListSlots[8]" slot-scope="{ item }" :value="item.pricingWithDrawAmount" :enabled="false" :decimals="spdAmountScale"/>
        <NumericBox :slot="spdListSlots[9]" slot-scope="{ item }" :value="item.pricingQuantity" :enabled="false" :decimals="spdQuantityScale" />
        <NumericBox :slot="spdListSlots[10]" slot-scope="{ item }" :value="item.pricingAmount" :enabled="false" :decimals="spdAmountScale" />
        <NumericBox :slot="spdListSlots[11]" v-if="item.hiddenPricingPrice==false" slot-scope="{ item }" :value="item.pricingPrice" :enabled="false" :decimals="spdPriceScale" />
        <TextBox :slot="spdListSlots[11]" v-else-if="item.hiddenPricingPrice==true"  slot-scope="{ item }" value="-" :enabled="false" class="cx_numric_box"/>
        <NumericBox :slot="spdListSlots[12]" slot-scope="{ item }" :value="item.lastPurchaseQuantity" :enabled="false" :decimals="spdQuantityScale" />
        <NumericBox :slot="spdListSlots[13]" slot-scope="{ item }" :value="item.lastPurchaseAmount" :enabled="false" :decimals="spdAmountScale" />
        <NumericBox :slot="spdListSlots[14]" slot-scope="{ item }" :value="item.lastPurchasePrice" :enabled="false" :decimals="spdPriceScale" />
        <template slot="footer" slot-scope="{ editor }">
          <EditPanel>
            <!-- 単価詳細ダイアログ フッタ項目 -->
            <template slot="left">
              <NumericBox title="受入数量合計" :value="spdFooterReceiptQuantity" :editor="editor" :enabled="false" :decimals="spdQuantityScale" tooltip="入荷や在庫移動、在庫振替などで在庫として受入れた数量の合計です。入荷の【調整数量】を含みます。" />
              <NumericBox title="受入金額合計" :value="spdFooterReceiptAmount" :editor="editor" :enabled="false" :decimals="spdAmountScale" tooltip="入荷や在庫移動、在庫振替などで在庫として受入れた金額の合計です。"/>
              <NumericBox title="払出数量合計" :value="spdFooterWithDrawQuantity" :editor="editor" :enabled="false" :decimals="spdQuantityScale" v-if="spdMonthlyOrMoving" tooltip="出荷や在庫移動、在庫振替などで在庫から払出した数量の合計です。"/>
              <NumericBox title="払出金額合計" :value="spdFooterWithDrawAmount" :editor="editor" :enabled="false" :decimals="spdAmountScale"  v-if="spdMonthlyOrMoving" tooltip="出荷や在庫移動、在庫振替などで在庫から払出した金額の合計です。"/>
            </template>
            <template slot="right">
              <NumericBox :title="spdItemName1" :value="spdFooterQuantity" :editor="editor" :enabled="false" :decimals="spdQuantityScale" tooltip="単価算出を行う数量です。受入数量から払出数量を差し引いた数量です。"/>
              <NumericBox :title="spdItemName2" :value="spdFooterAmount" :editor="editor" :enabled="false"  :decimals="spdAmountScale" tooltip="単価算出を行う金額です。受入金額から払出金額を差し引いた金額です。" />
              <NumericBox :title="spdItemName3" :value="spdFooterPrice" :editor="editor" :enabled="false"  :decimals="spdPriceScale" tooltip="算出された在庫単価です。"/>
            </template>
          </EditPanel>
        </template>
      </ListDialog>
      <!-- 在庫移動ダイアログ -->
      <ListDialog ref="showStockRelocationDialog" title="在庫移動" :buttonNames="asrButtonNames" modelName="StockBalance" :captions="asrCaptions" :widths="asrWidths" :showAdd="false" :showRemove="false" :execWithIndex="submitAddStockRelocation"
        :height="235" :width="1008">
        <!-- 在庫移動ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
            <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="asrWorkflowId" :editor="editor" list="workflow_stockRelocation" :required="true" :enabled="$api.perms.hasWorkflow('stockRelocation') && popup ==null" :nullValue="0"  @changed="onStockRelocationChangeWorkflow()" tooltip="在庫移動時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【在庫移動】になっているデータから選択ができます。"/>
              <Calendar title="発生日" :value.sync="asrBookDate" :editor="editor" :enabled="popup ==null" :deletable="false" tooltip="在庫移動の発生日を指定します。限月の範囲外の発生日は指定できません。発生日を含む限月の在庫を選択してください。" />
              <AtcCounterpart title="出庫倉庫" :value.sync="asrWarehouseOut" :needsWarehouse="true" :enabled="false" tooltip="選択された在庫を持つ倉庫です。在庫の移動元です。"/>
              <AtcCounterpart title="入庫倉庫" :value.sync="asrWarehouseIn" :editor="editor" :needsWarehouse="true" :enabled="popup ==null" :required="true" tooltip="在庫の移動先倉庫です。出庫倉庫と同じ倉庫を指定することはできません。" />
            </template>
            <template slot="right">
              <TextBox title="限月" :value="asrClosingDate | dateYM" :enabled="false" tooltip="選択された在庫の限月です。在庫一覧の検索条件で限月の指定・変更が可能です。" />
              <AtcSegment title="部門" :value.sync="asrSegment" :enabled="false" tooltip="選択された在庫の部門です。部門を跨ぐ在庫の移動は、在庫振替を利用してください。" />
              <AutoComplete title="担当者" :value.sync="asrPic" :editor="editor" list="user" :enabled="popup ==null" :required="true" tooltip="在庫移動を行う担当者を指定します。" />
            </template>
          </EditPanel>
        </template>
        <!-- 在庫移動ダイアログ 一覧項目 -->
        <AtcCommodity :slot="asrSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockKey.commodity" :enabled="false" />
        <TextBox :slot="asrSlots[1]" slot-scope="{ item, editor }" :value.sync="item.stockKey.commodity.uom" :editor="editor" :enabled="false" />
        <AtcSKU :slot="asrSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockKey.sku" :commodity="item.stockKey.commodity" :enabled="false" />
        <AtcProjectItem :slot="asrSlots[3]" slot-scope="{ item , editor }"  :value.sync="item.stockKey.projectItem" :editor="editor"  :enabled="false"/>         
        <NumericBox :slot="asrSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.scheduleStockQuantity" :enabled="false" :decimals="item.stockKey.commodity.quantityScale" />
        <NumericBox :slot="asrSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockRelocationQuantity" :required="true" min="0" :max="item.scheduleStockQuantity" :decimals="item.stockKey.commodity.quantityScale"  />

        <TextBox :slot="asrSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText1" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="asrSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText1:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="asrSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText2" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="asrSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText2:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="asrSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText3" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="asrSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText3:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="asrSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText4" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="asrSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText4:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="asrSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText5" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="asrSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText5:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="asrSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText6" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="asrSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText6:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="asrSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo1" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="asrSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo1:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="asrSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo2" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="asrSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo2:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="asrSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo3" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="asrSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo3:''" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="asrSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate1" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="asrSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate1: null" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="asrSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate2" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="asrSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate2: null" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="asrSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate3" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="asrSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate3: null" :editor="editor" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="asrSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList1" :editor="editor" list="category_41" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList1)" />
        <AutoComplete :slot="asrSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList1)" />
        <AutoComplete :slot="asrSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList2" :editor="editor" list="category_42" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList2)" />
        <AutoComplete :slot="asrSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList2)" />
        <AutoComplete :slot="asrSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList3" :editor="editor" list="category_43" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList3)" />
        <AutoComplete :slot="asrSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEnabledRelocation(tenantSettings.usedTypeDetailReserveList3)"/>
      </ListDialog>
      <!-- セット組立ダイアログ -->
      <ListDialog ref="showStockAssemblyDialog" title="セット組立" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitStockAssembly" >
        <template slot="header" slot-scope="{ editor }">
          <!-- <TextBox title="振替区分" value="セット組立" :editor="editor" :enabled="false" /> -->
          <TextBox title="セット品名称" :value="params.assembly ? params.assembly.name : ''" :editor="editor" :enabled="false" tooltip="作成するセット品の名称です。在庫一覧画面の検索条件【構成品抽出】で指定されたセット品を作成します。" />
          <NumericBox title="セット品数量" :value.sync="saAssemblyQuantity" :editor="editor" :decimals="params.assembly ? params.assembly.commodity.quantityScale : 0" :required="true" :more="0" :max="saLimitQuantity" tooltip="作成するセット品の数量です。この数量を元に在庫振替としてセット品の組み立てを行うことができます。" />
          <TextBox title="単位" :value="params.assembly ? params.assembly.commodity.uom : ''" :editor="editor" :enabled="false"  tooltip="セット品に指定されている商品の計上単位です。"/>
          <NumericBox title="組立可能数量" :value="saLimitQuantity" :editor="editor" :enabled="false" tooltip="【セット品数量】で指定可能な最大数量です。元となる構成品の【在庫数量】により決定します。" />
        </template>
      </ListDialog>
      <!-- セット分解ダイアログ -->
      <ListDialog ref="showStockDivideDialog" title="セット分解" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitStockDivide" >
        <template slot="header" slot-scope="{ editor }">
          <!-- <TextBox title="振替区分" value="セット分解" :editor="editor" :enabled="false" /> -->
          <TextBox title="セット品名称" :value="sdAssembly ? sdAssembly.name : ''" :editor="editor" :enabled="false" tooltip="分解するセット品の名称です。選択した在庫の【商品名称】です。" />
          <NumericBox title="セット品数量" :value.sync="sdAssemblyQuantity" :editor="editor" :decimals="sdAssembly ? sdAssembly.commodity.quantityScale :0" :required="true" :more="0" :max="sdLimitQuantity" tooltip="分解するセット品の数量です。分解可能数量が分解できる最大数量になります。" />
          <TextBox title="単位" :value="sdAssembly ? sdAssembly.commodity.uom : ''" :editor="editor" :enabled="false" tooltip="セット品に指定されている商品の計上単位です。" />
          <NumericBox title="分解可能数量" :value="sdLimitQuantity" :editor="editor" :enabled="false" :decimals="sdAssembly ? sdAssembly.commodity.quantityScale :0" tooltip="【セット品数量】で指定可能な最大数量です。元となるセット品の【在庫数量】により決定します。" />
        </template>
      </ListDialog>
      <!-- 在庫振替ダイアログ -->
      <ListDialog ref="showStockTransferDialog" title="在庫振替" :buttonNames="astrButtonNames" modelName="StockTransferItem"
      :captions="astrCaptionsIn"
      :widths="astrWidthsIn"
      :showAdd="isEditableRow()" :showRemove="isEditableRow()" :execWithIndex="submitAddStockTransfer" :height="135" :width="1000">
        <!-- 在庫振替ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <!-- 在庫振替ダイアログ ヘッダ項目 左側 -->
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="astrWorkflowId" :editor="editor" list="workflow_stockTransfer" :required="true" :enabled="$api.perms.hasWorkflow('stockTransfer') && popup == null" :nullValue="0" @changed="onStockTransferChangeWorkflow()" tooltip="在庫振替時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【在庫振替】になっているデータから選択ができます。" />
              <Calendar title="発生日" :value.sync="astrBookDate" :editor="editor" :enabled="popup == null" :deletable="false" tooltip="在庫振替の発生日を指定します。在庫限月の範囲外の発生日は指定できません。" />
              <AutoComplete title="担当者" :value.sync="astrPic" :editor="editor" :enabled="popup == null"  list="user" :required="true" tooltip="在庫振替を行う担当者を指定します。" />
              <TextBox title="管理番号" :value.sync="astrRefNo" :editor="editor" :enabled="popup == null"  length="30" tooltip="在庫振替の管理番号を指定します。" />
              <TextBox title="振替区分" :value="astrTransferFlagName" :editor="editor" :enabled="false" tooltip="【在庫振替】【セット品組立】【セット品分解】の区分が表示されます。" />
              <TextBox title="セット品名称" :value="astrAssemblyName" :editor="editor" :enabled="false" tooltip="【セット品組立】【セット品分解】の場合、セット品の名称が表示されます。" />
            </template>
            <template slot="right">
              <TextBox title="限月" :value="astrClosingDate | dateYM" :enabled="false" tooltip="選択された在庫の限月です。在庫一覧の検索条件で限月の指定・変更が可能です。" />
              <AtcSegment title="出庫部門" :value="astrSegmentOut" :enabled="false" tooltip="選択された、振替元の在庫を持つ部門です。" />
              <AtcCounterpart title="出庫倉庫" :value="astrWarehouseOut" :needsWarehouse="true" :enabled="false" tooltip="選択された振替元の在庫を持つ倉庫です。" />
              <AtcSegment title="入庫部門" :value.sync="astrSegmentIn" :enabled="astrTransferFlag == checkTransferFlag && popup == null" @changed="setTransferInPriceAll()" :required="true" :editor="editor" tooltip="在庫振替先の部門です。"/>
              <AtcCounterpart title="入庫倉庫" :value.sync="astrWarehouseIn" :needsWarehouse="true" :enabled="astrTransferFlag == checkTransferFlag && popup == null" :required="true" :editor="editor" tooltip="在庫振替先の倉庫です。"/>
            </template>
          </EditPanel>
          <div style="height:10px;"></div>
          <Grid ref="stockBalanceListBox" storageKey="stockBalanceList" :items="stockTransferItemsOut"
            :captions="astrCaptionsOut"
            :widths="astrWidthsOut"
            :key="astrKeyOut" height="200" :width="$api.spMode ? 'unset':'1000'"  :showGearButton="false">
              <GridItem :slot="astrSlotsOut[0]" slot-scope="{item}">{{item.commodity.name}}</GridItem>
              <GridItem :slot="astrSlotsOut[1]" slot-scope="{item}">{{item.commodity.uom}}</GridItem>
              <GridItem :slot="astrSlotsOut[2]" slot-scope="{item}">{{item.skuId ? item.sku.name : '' }}</GridItem>
              <GridItem :slot="astrSlotsOut[3]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>                
              <GridItem :slot="astrSlotsOut[4]" slot-scope="{item}">{{item.availableQuantity | numeric(item.commodity.quantityScale)}}</GridItem>
              <NumericBox :slot="astrSlotsOut[5]" slot-scope="{ item }" :value.sync="item.quantity" :editor="editor" :enabled="astrTransferFlag == checkTransferFlag" :decimals="item.commodity.quantityScale" :required="true" more="0" :max="item.availableQuantity" :nullValue="0" @update:value="setTransferOutAmount(item)" />
              <NumericBox :slot="astrSlotsOut[6]" slot-scope="{ item }" :value.sync="item.unitPrice" :editor="editor" :enabled="true" decimalsInput="6" more="0" max="999999999.999999" :nullValue="0" @update:value="setTransferOutAmount(item)" />
              <NumericBox :slot="astrSlotsOut[7]" slot-scope="{ item }" :value.sync="item.amount" :editor="editor" :enabled="false" :decimals="astrAmountScale" :nullValue="0" />

              <GridItem :slot="astrSlotsOut[8]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
              <GridItem :slot="astrSlotsOut[9]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
              <GridItem :slot="astrSlotsOut[10]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
              <GridItem :slot="astrSlotsOut[11]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
              <GridItem :slot="astrSlotsOut[12]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
              <GridItem :slot="astrSlotsOut[13]" slot-scope="{ item }">{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
              <GridItem :slot="astrSlotsOut[14]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
              <GridItem :slot="astrSlotsOut[15]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
              <GridItem :slot="astrSlotsOut[16]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
              <GridItem :slot="astrSlotsOut[17]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1) | date}}</GridItem>
              <GridItem :slot="astrSlotsOut[18]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2) | date}}</GridItem>
              <GridItem :slot="astrSlotsOut[19]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem> -->
              <GridItem :slot="astrSlotsOut[20]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
              <GridItem :slot="astrSlotsOut[21]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
              <GridItem :slot="astrSlotsOut[22]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem> 
          </Grid>
          <br>
        </template>
        <template slot="footer" slot-scope="{ editor }">
          <EditPanel>
            <!-- 在庫振替ダイアログ ヘッダ項目 左側 -->
            <template slot="left">
              <NumericBox title="出庫金額合計" :value="astrTotalAmountOut" :editor="editor" :enabled="false" :decimals="astrAmountScale" tooltip="出庫側の振替元在庫の【振替数量】×【単価】です。"  />
            </template>
            <template slot="right">
              <NumericBox title="入庫金額合計" :value="astrTotalAmountIn" :editor="editor" :enabled="false" :decimals="astrAmountScale" tooltip="入庫側の金額です。【出庫金額合計】と同じ値が設定されます。" />
            </template>
          </EditPanel>
        </template>
        <!-- 在庫振替ダイアログ 一覧項目(入荷明細) -->
        <AtcCommodity :slot="astrSlotsIn[0]" slot-scope="{ item , editor }" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="astrTransferFlag == checkTransferFlag" @changed="setPackage(item)"/>
        <TextBox :slot="astrSlotsIn[1]" slot-scope="{ item , editor }" :value.sync="item.package" :editor="editor" :enabled="false" />
        <AtcSKU :slot="astrSlotsIn[2]" slot-scope="{ item , editor }" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="astrTransferFlag == checkTransferFlag" />
        <AtcProjectItem :slot="astrSlotsIn[3]" slot-scope="{ item , editor }"  :value.sync="item.projectItem" :editor="editor"  :enabled="astrTransferFlag == checkTransferFlag"/>         
        <NumericBox :slot="astrSlotsIn[4]" slot-scope="{ item , editor }" :value.sync="item.quantity" :editor="editor" :enabled="astrTransferFlag == checkTransferFlag" decimals="3" :required="true" more="0" max="99999999.999" :nullValue="0" @update:value="setTransferInPrice(item)" />
        <NumericBox :slot="astrSlotsIn[5]" slot-scope="{ item , editor ,row}" :value.sync="item.amount" :enabled="row>0" :forceValidate="true" :editor="editor" :decimalsInput="astrAmountScale" :required="true" more="0" max="99999999999.99" :nullValue="0" @update:value="setTransferInPrice(item)"/>
        <NumericBox :slot="astrSlotsIn[6]" slot-scope="{ item , editor }" :value.sync="item.unitPrice" :editor="editor" :enabled="false" decimalsInput="6" :nullValue="0" />

        <TextBox :slot="astrSlotsIn[7]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText1)"/>
        <TextBox :slot="astrSlotsIn[7]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText1)"/>
        <TextBox :slot="astrSlotsIn[8]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText2)"/>
        <TextBox :slot="astrSlotsIn[8]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText2)"/>
        <TextBox :slot="astrSlotsIn[9]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText3)"/>
        <TextBox :slot="astrSlotsIn[9]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText3)"/>
        <TextBox :slot="astrSlotsIn[10]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText4)"/>
        <TextBox :slot="astrSlotsIn[10]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText4)"/>
        <TextBox :slot="astrSlotsIn[11]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText5)"/>
        <TextBox :slot="astrSlotsIn[11]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText5)"/>
        <TextBox :slot="astrSlotsIn[12]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText6)"/>
        <TextBox :slot="astrSlotsIn[12]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveText6)"/>
        <TextBox :slot="astrSlotsIn[13]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <TextBox :slot="astrSlotsIn[13]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <TextBox :slot="astrSlotsIn[14]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <TextBox :slot="astrSlotsIn[14]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <TextBox :slot="astrSlotsIn[15]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <TextBox :slot="astrSlotsIn[15]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar :slot="astrSlotsIn[16]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :deletable="true"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar :slot="astrSlotsIn[16]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :deletable="true"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar :slot="astrSlotsIn[17]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :deletable="true" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar :slot="astrSlotsIn[17]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :deletable="true" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar :slot="astrSlotsIn[18]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :deletable="true"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar :slot="astrSlotsIn[18]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :deletable="true"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveDate3)"/>
        <AutoComplete :slot="astrSlotsIn[19]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList1)" />
        <AutoComplete :slot="astrSlotsIn[19]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList1)" />
        <AutoComplete :slot="astrSlotsIn[20]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList2)" />
        <AutoComplete :slot="astrSlotsIn[20]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList2)" />
        <AutoComplete :slot="astrSlotsIn[21]" slot-scope="{ item , editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList3)" />
        <AutoComplete :slot="astrSlotsIn[21]" slot-scope="{ item , editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43"  :enabled="isEnabledStockIn(tenantSettings.usedTypeDetailReserveList3)" /> -->
      </ListDialog>
      <!-- 棚卸処理ダイアログ -->
      <ListDialog ref="showStockTakingDialog" title="棚卸処理" :buttonNames="astkButtonNames" modelName="StockBalance" :captions="astkCaptions" :widths="astkWidths" :showAdd="false" :showRemove="true" :execWithIndex="submitAddStockTaking" :height="235" :width="1008">
        <!-- 棚卸処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
              <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="astkWorkflowId" :editor="editor" list="workflow_stockTaking" :required="true" :enabled="$api.perms.hasWorkflow('stockTaking') && popup ==null" :nullValue="0" @changed="onStockTakingChangeWorkflow()" tooltip="棚卸処理時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【棚卸処理】になっているデータから選択ができます。" />
                <RadioButton title="処理区分" :value.sync="astkBarcodeInspection" list="barcodeInspectionFlags" :editor="editor" :enabled="isBarcodeInspection && popup ==null" tooltip="【結果入力】の場合は棚卸を行った結果を入力します。【バーコード検品】の場合はバーコード検品の結果で棚卸を行います。"/>                          
                <Calendar title="発生日" :value.sync="astkBookDate" :editor="editor" :enabled="popup ==null" :deletable="false" tooltip="棚卸の発生日を指定します。限月の範囲外の発生日は指定できません。" />
                <AutoComplete title="担当者" :value.sync="astkPic" :editor="editor" :enabled="popup ==null" list="user" :required="true" tooltip="棚卸処理を行う担当者を指定します。" />
    
                <TextBox title="管理番号" :value.sync="astkRefNo" :editor="editor" :enabled="popup ==null" length="30" tooltip="棚卸の管理番号を指定します。" />
              </template>
              <template slot="right">
                <TextBox title="限月" :value="astkClosingDate | dateYM" :enabled="false" tooltip="選択された在庫の限月です。在庫一覧の検索条件で限月の指定・変更が可能です。" />
                <AtcSegment title="部門" :value.sync="astkSegment" :enabled="false" tooltip="選択された在庫を持つ部門です。" />
                <AtcCounterpart title="倉庫" :value.sync="astkWarehouse" :needsWarehouse="true" :enabled="false" tooltip="選択された在庫を持つ倉庫です。" />
              </template>
          </EditPanel>


        </template>
        <!-- 棚卸処理ダイアログ 一覧項目 -->
        <AtcCommodity :slot="astkSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockKey.commodity" :enabled="false" />
        <TextBox :slot="astkSlots[1]" slot-scope="{ item, editor }" :value.sync="item.stockKey.commodity.uom" :editor="editor" :enabled="false" />
        <AtcSKU :slot="astkSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockKey.sku" :commodity="item.stockKey.commodity" :enabled="false" />
        <AtcProjectItem :slot="astkSlots[3]" slot-scope="{ item , editor }"  :value.sync="item.stockKey.projectItem" :editor="editor"  :enabled="false"/>                 
        <NumericBox :slot="astkSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockQuantity" :enabled="false" :decimals="item.stockKey.commodity.quantityScale" />
        <NumericBox :slot="astkSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.physicalStockQuantity" :required="false" min="0" max="99999999.999" :decimalsInput="item.stockKey.commodity.quantityScale" @update:value="setLossStockQuantity(item)" />
        <NumericBox :slot="astkSlots[6]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.lossStockQuantity" :enabled="false" :decimals="item.stockKey.commodity.quantityScale"  />

        <TextBox :slot="astkSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText1" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText2" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText3" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText3:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText4" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText4:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText5" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText5:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveText6" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveText6:''" :editor="editor" :enabled="false" />

        <TextBox :slot="astkSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo1" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo2" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveMemo3" :editor="editor" :enabled="false" />
        <TextBox :slot="astkSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveMemo3:''" :editor="editor" :enabled="false" />

        <Calendar :slot="astkSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate1" :editor="editor" :enabled="false" />
        <Calendar :slot="astkSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate1: null" :editor="editor" :enabled="false" />
        <Calendar :slot="astkSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate2" :editor="editor" :enabled="false" />
        <Calendar :slot="astkSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate2: null" :editor="editor" :enabled="false" />
        <Calendar :slot="astkSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveDate3" :editor="editor" :enabled="false" />
        <Calendar :slot="astkSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveDate3: null" :editor="editor" :enabled="false" />

        <AutoComplete :slot="astkSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList1" :editor="editor" list="category_41" :enabled="false" />
        <AutoComplete :slot="astkSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="false" />
        <AutoComplete :slot="astkSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList2" :editor="editor" list="category_42" :enabled="false" />
        <AutoComplete :slot="astkSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="false" />
        <AutoComplete :slot="astkSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.stockKey.reserveList3" :editor="editor" list="category_43" :enabled="false" />
        <AutoComplete :slot="astkSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo"  :value="item.stockKey.commodity != null ? item.stockKey.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="false" />
      </ListDialog>

      <!--諸掛按分処理ダイアログ -->
      <ListDialog ref="chargeAllocationDialog" title="諸掛按分処理" :buttonNames="caButtonNames" modelName="PurchaseCharge" :captions="caConfig.gridCaptions" :widths="caConfig.gridWidths"  :execWithIndex="submitChargeAllocation" :height="235" :width="1000">
        <!-- 諸掛按分処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="caWorkflowId" :editor="editor"  list="workflow_charge"  :required="$api.perms.hasWorkflow('charge')" :enabled="$api.perms.hasWorkflow('charge')" :nullValue="0"  @changed="onChargeAllocationChangeWorkflow()" tooltip="諸掛登録時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【諸掛管理】になっているデータから選択ができます。"/>
              <AutoComplete title="担当者" :value.sync="caPic" :editor="editor" :required="true" list="user" tooltip="諸掛按分を行う担当者を指定します。" />
              <Calendar title="発生日" :value.sync="caBookDate" :editor="editor" @update:value="onChangeChargeDate" tooltip="諸掛の発生日を指定します。在庫の限月以前の発生日は指定できません。"/>
              <ComboBox title="按分方法" :value.sync="caProportionalDivision" :editor="editor" :list="hasLicenseCurrency?'proportionalDivisionFlags2':'proportionalDivisionFlags2NoLicenseCurrency'" :required="true" tooltip="複数の在庫に按分する場合、指定された按分方法により按分額が決定されます。" />
              <ComboBox title="取引通貨" :value.sync="caCurrencyCode" :editor="editor" list="currency" v-if="hasLicenseCurrency" @update:value="onChangeCurrency"  :required="true" />
              <NumericBox title="計上レート" :value.sync="caExchangeRate" v-if="hasLicenseCurrency" :editor="editor" :nullValue="0" :required="true" :decimalsInput="6"/>
              <TextBox title="諸掛管理番号" :value.sync="caRefNo" :editor="editor" length="30" tooltip="諸掛の管理番号を指定します。" />
            </template>
          </EditPanel>
        </template>
        <!-- 諸掛按分処理ダイアログ 一覧項目 -->
        <AtcCounterpart :slot="caConfig.gridSlots[0]" slot-scope="{ item, editor }" :value.sync="item.counterpart" :editor="editor" :needsSupplier="true" :needsWarehouse="true" :required="true" @update:value="onChangeCounterpart(item)" />
        <AutoComplete  :slot="caConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.account" :editor="editor" query="PurchaseChargeAccountMasterQuery" :required="true" />
        <NumericBox  :slot="caConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.dealAmountFC" :editor="editor" :required="true" :decimalsInput="caAmountScale" />
        <AtcTaxCode  :slot="caConfig.gridSlots[3]" slot-scope="{ item, editor }" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true"/>
        <Calendar  :slot="caConfig.gridSlots[4]" slot-scope="{ item, editor }" :value.sync="item.dueDate" :editor="editor" :required="true"/>
      </ListDialog>
    </template>     
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import Moment from 'moment';

@Component
export default class StockBalanceView extends Vue {
  public items: Common.StockBalance[] = new Array(0);
  public params: Common.StockBalanceQuery = new Common.StockBalanceQuery();
  // public importQuery = new Common.StockTakingImportQuery('実地棚卸');
  // public exportQuery = new Common.StockTakingExportQuery('実地棚卸',this.params);
  public exportQuery = new Common.StockBalanceExportQuery('在庫一覧',this.params);
  public purchaseDeliveryVoucherType = Common.VoucherTypes.SalesDelivery;
  public salesDeliveryVoucherType = Common.VoucherTypes.SalesDelivery;
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;
  public usedTypes = Common.UsedTypes;
  public hasLicenseCurrency: boolean = false;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;
  @Prop() public closingDate:Date;
  @Prop() public segment:Common.Segment;  
  @Prop() public warehouse:Common.Counterpart;    
  @Prop() public projectItem:Common.ProjectItem;    
  @Prop({default:false}) public excludeProject: boolean;   
  @Prop({default:null}) public popup: Components.PopupEditor;
  @Prop({default:false}) public isStockPopup: boolean;  
  public sortOptions: any = [
    // { value: 'id', text: 'ID' },
    { value: 'warehouse', text: '倉庫' },    
    { value: 'segment', text: '部門' },
    { value: 'commodity', text: '商品' },
    { value: 'sku', text: 'SKU' },
    { value: 'commodityCode', text: '商品コード' },
    { value: 'projectItem', text: '案件' },    
  ];

  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();

  public stockTakingImportQuery = new Common.StockTakingImportQuery('実地棚卸');
  public stockTakingExportQuery = new Common.StockTakingExportQuery('実地棚卸',this.params);
  public migrationImportQuery = new Common.MigrationImportQuery('在庫移行');
  public migrationExportQuery = new Common.MigrationExportQuery('在庫移行',this.params);

  public created() {
    this.tenantSettings = this.$api.tenantSettings;
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItemsFromCaptions(
      // ['限月', '部門', '倉庫', '商品', 'SKU','繰越数量', '繰越金額', '移行数量', '移行金額', '未着数量', '未着金額', '仕入数量', '仕入金額', '仕入諸掛金額', '振替数量', '振替金額', '積送数量', '積送金額', '売上数量', '売上金額', '売上諸掛金額', '減耗数量', '在庫数量', '予定入荷数量', '予定出荷数量', '予定在庫数量', '払出金額', '在庫単価', '在庫金額', '入荷明細ID',],
      // [120, 120, 120, 120, 120,120, 120, 120, 120, 120, 120, 120, 120, 150, 120, 120, 120, 120, 120, 120, 150, 120, 120, 150, 150, 150, 150, 150, 150, 120, 120, 120,120]
      ['限月', '部門', '倉庫','案件', '商品コード', '商品', '型番', 'SKU','繰越在庫数量', '繰越在庫金額', '仕入数量', '仕入金額', '仕入諸掛金額', '振替数量', '振替金額','売上数量', '売上金額', '売上諸掛金額', '払出金額',  '減耗数量','減耗金額', '在庫数量','(庫内数量)','(積送数量)', '在庫単価', '在庫金額'],
      [120, 120, 120,120, 120, 120, 150, 150, 120, 120, 150, 120, 120, 120, 120, 150, 120, 120, 120, 120, 150, 120, 120,]
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));

    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.closingDate)this.params.closingDate = this.closingDate;
    if (this.segment)this.params.segment = this.segment;
    if (this.warehouse) this.params.warehouse = this.warehouse;
    if (this.projectItem) this.params.projectItem = this.projectItem;    
    if (this.excludeProject) this.params.excludeProject = this.excludeProject;
  }
  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.CommodityMemo ;
  }
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }

  // 在庫数量詳細
  public sbqFooterMigrationQuantity: number = 0;
  public sbqFooterUndeliveredQuantity: number = 0;
  public sbqFooterPurchaseQuantity: number = 0;
  public sbqFooterTransferQuantity: number = 0;
  public sbqFooterConsignmentQuantity: number = 0;
  public sbqFooterSalesQuantity: number = 0;
  public sbqFooterDifferentialQuantityActual: number = 0;
  public sbqFooterTotalUndeliveredQuantity: number = 0;
  public sbqFooterTotalConsignmentQuantity: number = 0;
  public sbqFooterTotalStockQuantity: number = 0;
  public sbqFooterStockQuantity: number = 0;
  public sbqFooterSchedulePurchaseQuantity: number = 0;
  public sbqFooterScheduleSalesQuantity: number = 0;
  public sbqFooterScheduleStockQuantity: number = 0;
  public sbqFooterQuantityScale = 0;
  public showStockBalanceQuantityDialog(){
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;
    
    if(stockBalance.isAggregation){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return;
    }
    
    this.$api.startWaitCusor();
    this.sbqFooterQuantityScale = stockBalance.stockKey.commodity.quantityScale;
    this.sbqFooterMigrationQuantity = stockBalance.migrationQuantity;
    // クエリの設定
    var query = new Common.StockBalanceDetailQuery();
    query.stockBalance = stockBalance;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.sbqFooterUndeliveredQuantity =  journals.map(obj => obj.undeliveredQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterPurchaseQuantity = journals.map(obj => obj.purchaseQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterTransferQuantity = journals.map(obj => obj.transferQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterConsignmentQuantity = journals.map(obj => obj.consignmentQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterSalesQuantity = journals.map(obj => obj.salesQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterDifferentialQuantityActual = journals.map(obj => obj.differentialQuantityActual).reduce((total, value) =>(total + value));
      this.sbqFooterTotalUndeliveredQuantity = journals[journals.length -1].totalUndeliveredQuantity;
      this.sbqFooterTotalConsignmentQuantity = journals[journals.length -1].totalConsignmentQuantity;
      this.sbqFooterTotalStockQuantity = journals[journals.length -1].totalStockQuantity;
      this.sbqFooterStockQuantity = journals[journals.length -1].stockQuantity;
      this.sbqFooterSchedulePurchaseQuantity = journals.map(obj => obj.schedulePurchaseQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterScheduleSalesQuantity = journals.map(obj => obj.scheduleSalesQuantity).reduce((total, value) =>(total + value));
      this.sbqFooterScheduleStockQuantity = journals[journals.length -1].totalScheduleStockQuantity;
      (this.$refs.stockBalanceQuantityDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
      (this.$refs.stockBalanceQuantityDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());
  }

  // 在庫金額詳細
  public sbaFooterMigrationAmount: number = 0;
  public sbaFooterUndeliveredAmount: number = 0;
  public sbaFooterPurchaseAmount: number = 0;
  public sbaFooterPurchaseChargeAmount: number = 0;
  public sbaFooterTransferAmount: number = 0;
  public sbaFooterConsignmentAmount: number = 0;
  public sbaFooterSalesAmount: number = 0;
  public sbaFooterSalesChargeAmount: number = 0;
  public sbaFooterQuantityLossAmount: number = 0;
  public sbaFooterWithDrawAmount: number = 0;
  public sbaFooterTotalUndeliveredAmount: number = 0;
  public sbaFooterTotalConsignmentAmount: number = 0;
  public sbaFooterStockAmount: number = 0;
  public sbaFooterTotalStockAmount: number = 0;
  public sbaFooterAmountScale: number = 0;

  public showStockBalanceAmountDialog(){
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;
    if(stockBalance.isAggregation){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return;
    }
    
    this.$api.startWaitCusor();
    this.sbaFooterAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);
    this.sbaFooterMigrationAmount = stockBalance.migrationAmount;
    // クエリの設定
    var query = new Common.StockBalanceDetailQuery();
    query.stockBalance = stockBalance;
    query.amountFlag = true;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.sbaFooterUndeliveredAmount =  journals.map(obj => obj.undeliveredAmount).reduce((total, value) =>(total + value));
      this.sbaFooterPurchaseAmount = journals.map(obj => obj.purchaseAmount).reduce((total, value) =>(total + value));
      this.sbaFooterPurchaseChargeAmount = journals.map(obj => obj.purchaseChargeAmount).reduce((total, value) =>(total + value));
      this.sbaFooterTransferAmount = journals.map(obj => obj.transferAmount).reduce((total, value) =>(total + value));
      this.sbaFooterConsignmentAmount = journals.map(obj => obj.consignmentAmount).reduce((total, value) =>(total + value));
      this.sbaFooterSalesAmount = journals.map(obj => obj.salesAmount).reduce((total, value) =>(total + value));
      this.sbaFooterSalesChargeAmount = journals.map(obj => obj.salesChargeAmount).reduce((total, value) =>(total + value));
      this.sbaFooterQuantityLossAmount = journals.map(obj => obj.quantityLossAmount).reduce((total, value) =>(total + value));
      this.sbaFooterWithDrawAmount = journals.map(obj => obj.withDrawAmount).reduce((total, value) =>(total + value));
      this.sbaFooterTotalUndeliveredAmount = journals[journals.length -1].totalUndeliveredAmount;
      this.sbaFooterTotalConsignmentAmount = journals[journals.length -1].totalConsignmentAmount;
      this.sbaFooterTotalStockAmount = journals[journals.length -1].totalStockAmount;

      this.sbaFooterTotalConsignmentAmount = stockBalance.totalConsignmentAmount;
      this.sbaFooterStockAmount = stockBalance.stockAmount;

      (this.$refs.stockBalanceAmountDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
      (this.$refs.stockBalanceAmountDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());
  }

  // 単価詳細プロパティ
  public spdFooterReceiptQuantity: number = 0;
  public spdFooterReceiptAmount:number = 0;
  public spdFooterWithDrawQuantity: number = 0;
  public spdFooterWithDrawAmount: number = 0;
  public spdMonthlyAverage:boolean = false;
  public spdMovingAverage:boolean = false;
  public spdLastPurchase:boolean = false;
  public spdSpecific:boolean = false;
  public spdFooterQuantity: number = 0;
  public spdFooterAmount: number = 0;
  public spdFooterPrice: number = 0;
  public spdItemName1: string = '';
  public spdItemName2: string = '';
  public spdItemName3: string = '';
  public spdQuantityScale: number = 0;
  public spdAmountScale: number = 0;
  public spdPriceScale: number = 0;
  public get spdMonthlyOrMoving():boolean
  {
    if (this.spdMonthlyAverage || this.spdMovingAverage) return true;
    else return false;
  }
  public spdListCaptions = new Array();
  public spdListWidths = new Array();
  public spdListSlots = new Array();
  public spdGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');
  public showStockPricingDetailDialog(){
    const stockBalance = (this.$refs.mainList as Components.ListView).selected as Common.StockBalance;
    
    if(stockBalance && stockBalance.isAggregation){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return;
    }
    
    if(stockBalance.stockPricingId == null){
      this.$api.modal.show('', '単価情報が存在しません。', true, null);
      return;
    }

    this.spdQuantityScale = stockBalance.stockKey.commodity.quantityScale;
    this.spdPriceScale = stockBalance.stockKey.commodity.stockPriceScale;
    this.spdAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);

    this.$api.startWaitCusor();
    this.spdMonthlyAverage = false;
    this.spdMovingAverage = false;
    this.spdSpecific = false;
    this.spdLastPurchase = false;
    if (stockBalance.stockKey.deliveryId != null || stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific)
    {
      this.spdSpecific = true;
      this.spdItemName1 = '個別数量';
      this.spdItemName2 = '個別金額';
      this.spdItemName3 = '個別単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.MonthlyAverage)
    {
      this.spdMonthlyAverage = true;
      this.spdItemName1 = '総平均数量';
      this.spdItemName2 = '総平均金額';
      this.spdItemName3 = '総平均単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.MovingAverage)
    {
      this.spdMovingAverage = true;
      this.spdItemName1 = '移動平均数量';
      this.spdItemName2 = '移動平均金額';
      this.spdItemName3 = '移動平均単価'
    }
    else if (stockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.LastPurchase)
    {
      this.spdLastPurchase = true;
      this.spdItemName1 = '最終原価数量';
      this.spdItemName2 = '最終原価金額';
      this.spdItemName3 = '最終原価単価'
    }

    this.spdFooterReceiptQuantity = 0;
    this.spdFooterReceiptAmount = 0;
    this.spdFooterWithDrawQuantity = 0;
    this.spdFooterWithDrawAmount = 0;
    this.spdFooterQuantity = 0;
    this.spdFooterAmount = 0;
    this.spdFooterPrice = 0;
    this.spdListCaptions = new Array();
    this.spdListWidths = new Array();
    this.spdListSlots = new Array();
    this.spdGridConfig = new Common.GridConfiguration([],0, 'col');

    this.spdGridConfig.setGridItems(
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('伝票区分', 150),
      new Common.GridItemConfiguration('伝票明細番号', 180),
      new Common.GridItemConfiguration('受入数量', 150),
      new Common.GridItemConfiguration('受入単価', 150),
      new Common.GridItemConfiguration('受入金額', 150),
      new Common.GridItemConfiguration('払出数量', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration('払出単価', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration('払出金額', 150, this.spdMonthlyOrMoving),
      new Common.GridItemConfiguration(this.spdItemName1, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName2, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName3, 150 , this.spdLastPurchase == false),
      new Common.GridItemConfiguration(this.spdItemName1, 150 , this.spdLastPurchase),
      new Common.GridItemConfiguration(this.spdItemName2, 150 , this.spdLastPurchase),
      new Common.GridItemConfiguration(this.spdItemName3, 150 , this.spdLastPurchase),
    );
    this.spdListCaptions = this.spdGridConfig.gridCaptions;
    this.spdListWidths = this.spdGridConfig.gridWidths;
    this.spdListSlots = this.spdGridConfig.gridSlots;

    // クエリの設定
    var query = new Common.StockPricingDetailQuery();
    query.stockBalance = stockBalance;

    // 在庫情報をロードする
    this.$api.execute(query).then(res => {
      var journals:Common.StockBalanceJournal[] = (res as Common.LoadResult).result;
      this.spdFooterReceiptQuantity = journals.map(obj => obj.receiptQuantity).reduce((total, value) =>(total + value));
      this.spdFooterReceiptAmount = journals.map(obj => obj.receiptAmount).reduce((total, value) =>(total + value));

      if(this.spdMonthlyAverage || this.spdSpecific || this.spdMovingAverage)
      {
        this.spdFooterWithDrawQuantity = journals.map(obj => obj.withDrawQuantity).reduce((total, value) =>(total + value));
        this.spdFooterWithDrawAmount = journals.map(obj => obj.pricingWithDrawAmount).reduce((total, value) =>(total + value));
        this.spdFooterQuantity = journals[journals.length -1].pricingQuantity;
        this.spdFooterAmount = journals[journals.length -1].pricingAmount;
        this.spdFooterPrice = journals[journals.length -1].pricingPrice;
      }
      else if(this.spdLastPurchase)
      {
        this.spdFooterQuantity = journals[journals.length -1].lastPurchaseQuantity;
        this.spdFooterAmount = journals[journals.length -1].lastPurchaseAmount;
        this.spdFooterPrice = journals[journals.length -1].lastPurchasePrice;
      }

      (this.$refs.showStockPricingDetailDialog as Components.ListDialog).items = (res as Common.LoadResult).result;
      (this.$refs.showStockPricingDetailDialog as Components.ListDialog).showDialog();
    }).finally(()=>this.$api.closeWaitCursor());;
  }

  // 一覧でチェックされている在庫
  public checkedStockBalances: Array<Common.StockBalance>= new Array(0);
  public getCheckedStockBalances(){
    this.checkedStockBalances = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.stockRelocationQuantity = 0;
        obj.physicalStockQuantity = 0;
        obj.lossStockQuantity = obj.stockQuantity;
        this.checkedStockBalances.push(obj);
      }
    });
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 帳票やファイル出力の前のチェック
  public validateNotAggregated(): boolean {
    if(this.params.aggregationType != null && this.params.aggregationType != Common.StockBalanceAggregationTypes.None){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return false;
    }
    return true;
  }

  // 在庫系処理の共通チェック
  public stockCommonCheck():boolean
  {
    if(this.params.aggregationType != null && this.params.aggregationType != Common.StockBalanceAggregationTypes.None){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return false;
    }
    if(this.checkedStockBalances.length == 0){
      this.$api.modal.show('', '在庫を選択して下さい。', true, null);
      return false;
    }
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.commodity.isNoStock).length > 0){
      this.$api.modal.show('', '棚卸対象外商品の在庫は選択できません。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.warehouseId == null).length > 0){
      this.$api.modal.show('', '直送管理用の在庫は選択できません。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> this.checkedStockBalances[0].stockKey.segmentId != StockBalance.stockKey.segmentId).length > 0){
      this.$api.modal.show('', '単一部門の在庫を選択してください。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> this.checkedStockBalances[0].stockKey.warehouseId != StockBalance.stockKey.warehouseId).length > 0){
      this.$api.modal.show('', '単一倉庫を選択してください。', true, null);
      return false;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.closingDate != null && StockBalance.stockKey.segment.closingDate >= StockBalance.closingDate).length > 0){
      this.$api.modal.show('', '締処理済みの在庫が指定されています。部門または限月を変更して下さい。', true, null);
      return false;
    }

    return true;
  }

  // 在庫移動用プロパティ
  public asrSegment: Common.Segment = null;
  public asrPic: string = '';
  public asrWarehouseOut: Common.Counterpart = null;
  public asrWarehouseIn: Common.Counterpart = null;
  public asrBookDate: Date = new Date().getCalendarDate();
  public asrClosingDate:Date = new Date().getCalendarDate();
  public asrWorkflowId:number = 0;
  public asrCaptions = new Array();
  public asrWidths = new Array();
  public asrSlots = new Array();
  public asrStockRelocation: Common.StockRelocation = null;//ポップアップエディタ使用時の親伝票
  public asrUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ
  // ワークフロー処理用プロパティ
  public asrButtonNames: Array<string> = null;
  public asrButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public asrGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('移動可能数量', 150),
      new Common.GridItemConfiguration('移動数量', 150)
    ],
    6, //移動数量の次を予備項目の挿入位置に指定
    'col'
  );

  // 在庫移動子画面表示
  public showStockRelocationDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.asrGridConfig.setVariableItems(reserveItems);
    this.asrCaptions =this.asrGridConfig.gridCaptions;
    this.asrWidths = this.asrGridConfig.gridWidths;
    this.asrSlots = this.asrGridConfig.gridSlots;

    // 入力項目の初期化
    if (this.asrStockRelocation == null) {
      this.asrSegment = this.checkedStockBalances[0].stockKey.segment;
      this.asrPic = this.$api.auth.userId;
      this.asrWarehouseOut = this.checkedStockBalances[0].stockKey.warehouse;
      this.asrWarehouseIn = this.asrWarehouseOut;//初期値をセット
      this.asrBookDate = new Date().getCalendarDate();
      this.asrClosingDate = this.checkedStockBalances[0].closingDate;
      this.asrWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockRelocation');
    }      
    
    this.onStockRelocationChangeWorkflow();


    // ダイアログの表示
    (this.$refs.showStockRelocationDialog as Components.ListDialog).items = this.checkedStockBalances;
    (this.$refs.showStockRelocationDialog as Components.ListDialog).showDialog();
  }
  public onStockRelocationChangeWorkflow(){
    this.asrButtonNames=new Array();
    this.asrButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.asrButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.asrButtonNames.push("保存");
    if(this.asrWorkflowId!=0 && this.popup == null) //ポップアップエディタで表示された場合は既存伝票への追加モードになるので確定ボタンは追加しない
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockRelocation', this.asrWorkflowId, Common.StockRelocationStatus.PostWaiting);
      actions.forEach(action => {
        this.asrButtonNames.push(action.actionName);
        this.asrButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }

  public async submitAddStockRelocation(list: Array<Common.StockBalance>, index:number){

    // 入力時チェック
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockRelocationQuantity > 0).length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で移動数量を指定して下さい。').then(()=>false);
    }

    if(Moment(this.asrClosingDate).format('YYYYMM') != Moment(this.asrBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>false);
    }

    // クエリ設定
    var query = new Common.CreateStockRelocationQuery();
    query.pic = this.asrPic;
    query.warehouseIn = this.asrWarehouseIn;
    query.bookDate = this.asrBookDate;
    query.stockBalances = this.checkedStockBalances;
    query.workflowId = this.asrWorkflowId;
    query.actionId = this.asrButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockRelocation = this.asrStockRelocation; //ポップアップエディタを使用した追加モード時の親伝票

    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });

    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.asrUpdatedHandler){
        this.asrUpdatedHandler();
        return true;
      }
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockRelocation;
      //this.$api.modal.show('処理結果','以下の在庫移動伝票が作成されました。',true,null,[new Common.ModalLink(result.stockRelocationNo,String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo))]);
      this.$api.modal.show('処理結果','以下の在庫移動伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo)),[new Common.ModalLink(result.stockRelocationNo,String.format('/journal/StockRelocation?stockRelocationNo={0}',result.stockRelocationNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});

  }

  // セット組立用プロパティ
  public saAssemblyQuantity:number = 0;
  public saLimitQuantity:number = 0;

  public showStockAssemblyDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(this.params.assembly == null){
      this.$api.modal.show('', 'セット組立時は検索条件タブで構成品抽出を指定して下さい。', true, null);
      return;
    }

    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific).length >0){
      this.$api.modal.show('', '在庫単価計算方法が個別法の部門は選択できません。', true, null);
      return;
    }
    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.projectItemNo != this.checkedStockBalances[0].stockKey.projectItemNo).length >0){
      this.$api.modal.show('', '異なる案件の構成品からセット品組立を実施することはできません。', true, null);
      return;
    }
    // クエリの設定
    var query = new Common.StockAssemblyQuery();
    query.assembly = this.params.assembly;
    query.stockBalances = this.checkedStockBalances;
    this.saAssemblyQuantity = 0;

    // セット組立を実行する
    this.$api.execute(query).then(res => {
      this.saLimitQuantity = (res as Common.Component).limitQuantity;
      (this.$refs.showStockAssemblyDialog as Components.ListDialog).showDialog();
    });
  }

  public async submitStockAssembly(){
    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);

    var query = new Common.StockTransferItemOutQuery();
    query.assembly = this.params.assembly;
    query.assemblyQuantity = this.saAssemblyQuantity;
    query.stockBalances = this.checkedStockBalances;
    await this.$api.execute(query).then(res => {
      // 出庫設定
      this.stockTransferItemsOut = res;
      // 入庫設定
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = this.params.assembly.commodity;
      temp.commodityId = this.params.assembly.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = this.params.assembly.sku;
      temp.skuId = this.params.assembly.skuId;
      temp.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
      temp.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;
      temp.quantity = this.saAssemblyQuantity;
      temp.amount = this.astrTotalAmountOut;
      temp.reserveText1 = this.params.assembly.reserveText1;
      temp.reserveText2 = this.params.assembly.reserveText2;
      temp.reserveText3 = this.params.assembly.reserveText3;
      temp.reserveText4 = this.params.assembly.reserveText4;
      temp.reserveText5 = this.params.assembly.reserveText5;
      temp.reserveText6 = this.params.assembly.reserveText6;
      temp.reserveMemo1 = this.params.assembly.reserveMemo1;
      temp.reserveMemo2 = this.params.assembly.reserveMemo2;
      temp.reserveMemo3 = this.params.assembly.reserveMemo3;
      temp.reserveDate1 = this.params.assembly.reserveDate1;
      temp.reserveDate2 = this.params.assembly.reserveDate2;
      temp.reserveDate3 = this.params.assembly.reserveDate3;
      temp.reserveList1 = this.params.assembly.reserveList1;
      temp.reserveList2 = this.params.assembly.reserveList2;
      temp.reserveList3 = this.params.assembly.reserveList3;
      this.stockTransferItemsIn.push(temp);
      // 在庫振替起動
      this.showStockTransferDialog(Common.TransferTypes.Assemble,'セット組立',this.params.assembly.name);
    });

  }

  // セット分解用プロパティ
  public sdAssemblyQuantity: number = 0;
  public sdLimitQuantity:number = 0;
  public sdAssembly:Common.Assembly = null;

  public showStockDivideDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(this.checkedStockBalances.length > 1){
      this.$api.modal.show('', 'セット分解は単一在庫のみ可能です。', true, null);
      return;
    }

    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.stockKey.segment.priceCalculationMethod == Common.PricingTypes.Specific).length >0){
      this.$api.modal.show('', '在庫単価計算方法が個別法の部門は選択できません。', true, null);
      return;
    }

    // クエリの設定
    var query = new Common.StockDivideQuery();
    query.stockBalance = this.checkedStockBalances[0];
    this.sdAssemblyQuantity = 0;
    this.sdLimitQuantity = this.checkedStockBalances[0].scheduleStockQuantity;

    // セット分解可能チェック
    this.$api.execute(query).then(res => {
      this.sdAssembly = res;
      (this.$refs.showStockDivideDialog as Components.ListDialog).showDialog();
    });
  }

  public async submitStockDivide(){
    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);

    var query = new Common.StockTransferItemInQuery();
    query.assembly = this.sdAssembly;
    query.assemblyQuantity = this.sdAssemblyQuantity;
    query.segment = this.checkedStockBalances[0].stockKey.segment;
    await this.$api.execute(query).then(res => {
      // 入庫設定
      this.stockTransferItemsIn = res;
      this.stockTransferItemsIn.forEach(item =>{
        item.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
        item.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;      
      });
      // 出庫設定
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = this.checkedStockBalances[0].stockKey.commodity;
      temp.commodityId = this.checkedStockBalances[0].stockKey.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = this.checkedStockBalances[0].stockKey.sku;
      temp.skuId = this.checkedStockBalances[0].stockKey.skuId;
      temp.projectItem = this.checkedStockBalances[0].stockKey.projectItem;
      temp.projectItemNo = this.checkedStockBalances[0].stockKey.projectItemNo;      
      temp.availableQuantity = this.checkedStockBalances[0].scheduleStockQuantity;
      temp.quantity = this.sdAssemblyQuantity;
      temp.unitPrice = this.checkedStockBalances[0].stockPrice;
      temp.reserveText1 = this.checkedStockBalances[0].stockKey.reserveText1;
      temp.reserveText2 = this.checkedStockBalances[0].stockKey.reserveText2;
      temp.reserveText3 = this.checkedStockBalances[0].stockKey.reserveText3;
      temp.reserveText4 = this.checkedStockBalances[0].stockKey.reserveText4;
      temp.reserveText5 = this.checkedStockBalances[0].stockKey.reserveText5;
      temp.reserveText6 = this.checkedStockBalances[0].stockKey.reserveText6;
      temp.reserveMemo1 = this.checkedStockBalances[0].stockKey.reserveMemo1;
      temp.reserveMemo2 = this.checkedStockBalances[0].stockKey.reserveMemo2;
      temp.reserveMemo3 = this.checkedStockBalances[0].stockKey.reserveMemo3;
      temp.reserveDate1 = this.checkedStockBalances[0].stockKey.reserveDate1;
      temp.reserveDate2 = this.checkedStockBalances[0].stockKey.reserveDate2;
      temp.reserveDate3 = this.checkedStockBalances[0].stockKey.reserveDate3;
      temp.reserveList1 = this.checkedStockBalances[0].stockKey.reserveList1;
      temp.reserveList2 = this.checkedStockBalances[0].stockKey.reserveList2;
      temp.reserveList3 = this.checkedStockBalances[0].stockKey.reserveList3;
      temp.specificPurchaseItemId = this.checkedStockBalances[0].stockKey.deliveryId;
      this.stockTransferItemsOut.push(temp);
      // 在庫振替起動
      this.showStockTransferDialog(Common.TransferTypes.Divide,'セット分解',this.sdAssembly.name);
    });

  }

  // 在庫振替用プロパティ
  public astrPic: string = '';
  public astrBookDate: Date = new Date().getCalendarDate();
  public astrRefNo: string = '';
  public astrClosingDate:Date = new Date().getCalendarDate();
  public astrTransferFlag: Common.TransferTypes = Common.TransferTypes.Transfer;
  public checkTransferFlag: Common.TransferTypes = Common.TransferTypes.Transfer;
  public astrTransferFlagName: string = '';
  public astrAssemblyName:string = '';
  public astrSystemCurrency:Common.Currency = null;
  public astrWorkflowId : number = 0;
  public astrStockTransfer: Common.StockTransfer = null;//ポップアップエディタ使用時の親伝票
  public astrUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ

  public astrSegmentOut: Common.Segment = null;
  public astrWarehouseOut: Common.Counterpart = null;
  public get astrTotalAmountOut(): number {
    if(this.stockTransferItemsOut.length == 0) return 0;
    return this.stockTransferItemsOut.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }
  public astrSegmentIn: Common.Segment = null;
  public astrWarehouseIn: Common.Counterpart = null;
  public get astrTotalAmountIn(): number {
     if(this.stockTransferItemsIn.length == 0) return 0;
    return this.stockTransferItemsIn.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }

  public stockTransferItemsOut: Array<Common.StockTransferItem>= new Array(0);
  public stockTransferItemsIn: Array<Common.StockTransferItem>= new Array(0);

  public astrCaptionsOut = new Array();
  public astrWidthsOut = new Array();
  public astrSlotsOut = new Array();
  public astrGridConfigOut:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 60),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('振替可能数量', 110),
      new Common.GridItemConfiguration('振替数量', 100),
      new Common.GridItemConfiguration('出庫単価', 100),
      new Common.GridItemConfiguration('出庫金額', 100)
    ],
    8, //出庫金額の次を予備項目の挿入位置に指定
    'col'
  );
  public astrKeyOut: string = "astrKeyOut"; // 再描画用

  public astrCaptionsIn = new Array();
  public astrWidthsIn = new Array();
  public astrSlotsIn = new Array();
  public astrAmountScale: number = 0;
  // ワークフロー処理用プロパティ
  public astrButtonNames: Array<string> = null;
  public astrButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public astrGridConfigIn:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 80),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),        
      new Common.GridItemConfiguration('振替数量', 100),
      new Common.GridItemConfiguration('入庫金額', 100),
      new Common.GridItemConfiguration('入庫単価', 100),
    ],
    7, //入庫金額の次を予備項目の挿入位置に指定
    'col'
  );

  // 在庫振替表示事前処理
  public showPriviousStockTransferDialog(){
    this.getCheckedStockBalances();

    this.astrAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    if(this.checkedStockBalances.filter(StockBalance=> StockBalance.scheduleStockQuantity <= 0).length >0){
      this.$api.modal.show('', '予定在庫数量0以下の在庫が選択されています。', true, null);
      return;
    }

    this.stockTransferItemsOut = new Array(0);
    this.stockTransferItemsIn = new Array(0);
    this.checkedStockBalances.forEach((obj, index) => {
      var temp: Common.StockTransferItem = new Common.StockTransferItem();
      temp.commodity = obj.stockKey.commodity;
      temp.commodityId = obj.stockKey.commodityId;
      temp.package = temp.commodity.uom;
      temp.sku = obj.stockKey.sku;
      temp.skuId = obj.stockKey.skuId;
      temp.projectItem = obj.stockKey.projectItem;
      temp.projectItemNo = obj.stockKey.projectItemNo;
      temp.availableQuantity = obj.scheduleStockQuantity;
      temp.quantity = 0;
      temp.unitPrice = obj.stockPrice;
      temp.amount = 0;
      temp.reserveText1 = obj.stockKey.reserveText1;
      temp.reserveText2 = obj.stockKey.reserveText2;
      temp.reserveText3 = obj.stockKey.reserveText3;
      temp.reserveText4 = obj.stockKey.reserveText4;
      temp.reserveText5 = obj.stockKey.reserveText5;
      temp.reserveText6 = obj.stockKey.reserveText6;
      temp.reserveMemo1 = obj.stockKey.reserveMemo1;
      temp.reserveMemo2 = obj.stockKey.reserveMemo2;
      temp.reserveMemo3 = obj.stockKey.reserveMemo3;
      temp.reserveDate1 = obj.stockKey.reserveDate1;
      temp.reserveDate2 = obj.stockKey.reserveDate2;
      temp.reserveDate3 = obj.stockKey.reserveDate3;
      temp.reserveList1 = obj.stockKey.reserveList1;
      temp.reserveList2 = obj.stockKey.reserveList2;
      temp.reserveList3 = obj.stockKey.reserveList3;
      temp.specificPurchaseItemId = obj.stockKey.deliveryId;
      temp.tempNo = index + 1;
      this.stockTransferItemsOut.push(temp);
      var temp2 = temp.copy();
      temp2.unitPrice = 0;
      temp2.specificPurchaseItemId = null;
      this.stockTransferItemsIn.push(temp2);
    });

    this.showStockTransferDialog(Common.TransferTypes.Transfer,'在庫振替');

  }

  public isEnabledRelocation(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.StockAttribute;
  }

  //入庫側の予備項目の編集可否を制御
  public isEnabledStockIn(usedType: Common.UsedTypes){
    //在庫振替の場合は商品識別情報と在庫識別情報のみ編集可。セット分解・組立の場合は在庫属性のみ
      if (this.astrTransferFlag == Common.TransferTypes.Transfer) {
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute) { return true;}else return false;
      }else return usedType == Common.UsedTypes.StockAttribute;
  }
  // 在庫振替
  public async showStockTransferDialog(flag:Common.TransferTypes,flagName:string,name:string = ''){

    // 予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.astrGridConfigOut.setVariableItems(reserveItems);
    this.astrCaptionsOut =this.astrGridConfigOut.gridCaptions;
    this.astrWidthsOut = this.astrGridConfigOut.gridWidths;
    this.astrSlotsOut = this.astrGridConfigOut.gridSlots;
    this.astrKeyOut = "astrKeyOut" + new Date();
    this.astrGridConfigIn.setVariableItems(reserveItems);
    this.astrCaptionsIn =this.astrGridConfigIn.gridCaptions;
    this.astrWidthsIn = this.astrGridConfigIn.gridWidths;
    this.astrSlotsIn = this.astrGridConfigIn.gridSlots;

    this.astrTransferFlag = flag;
    this.astrTransferFlagName = flagName;
    this.astrAssemblyName = name;
    // 入力項目初期化
    if (this.astrStockTransfer == null) {
      this.astrPic = this.$api.auth.userId;
      this.astrBookDate = new Date().getCalendarDate();
      this.astrRefNo = '';
      this.astrClosingDate = this.checkedStockBalances[0].closingDate;
      this.astrSegmentOut = this.checkedStockBalances[0].stockKey.segment;
      this.astrWarehouseOut = this.checkedStockBalances[0].stockKey.warehouse;
      this.astrSegmentIn = this.checkedStockBalances[0].stockKey.segment;
      this.astrWarehouseIn = this.checkedStockBalances[0].stockKey.warehouse;
      this.astrWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockTransfer');
    }

    this.onStockTransferChangeWorkflow();

    var query = new Common.GetSystemCurrecy();
    await this.$api.execute(query).then(res => {
      this.astrSystemCurrency = res;
      // 出庫金額の計算
      this.stockTransferItemsOut.forEach((obj, index) => {
        this.setTransferOutAmount(obj);
      });
      // 入庫単価の計算
      this.setTransferInPriceAll();
      // ダイアログの表示
      (this.$refs.showStockTransferDialog as Components.ListDialog).items = this.stockTransferItemsIn;
      (this.$refs.showStockTransferDialog as Components.ListDialog).showDialog();
    });
  }
  public onStockTransferChangeWorkflow(){
    this.astrButtonNames=new Array();
    this.astrButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.astrButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.astrButtonNames.push("保存");
    if(this.astrWorkflowId!=0 && this.popup == null)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockTransfer', this.astrWorkflowId, Common.StockTransferStatus.PostWaiting);
      actions.forEach(action => {
        this.astrButtonNames.push(action.actionName);
        this.astrButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }


  @Watch('stockTransferItemsOut',{deep:true})
  @Watch('stockTransferItemsIn',{deep:true})
  public setStockInAmount(){
    //入庫明細(1行目)の入庫金額に出庫金額-入庫金額を加算する
    if (this.stockTransferItemsOut && this.stockTransferItemsOut.length > 0 && this.stockTransferItemsIn && this.stockTransferItemsIn.length > 0){
      var stockOut = this.stockTransferItemsOut.map(obj =>obj.amount).reduce((previous,current)=>previous+current);
      var stockIn = this.stockTransferItemsIn.map(obj =>obj.amount).reduce((previous,current)=>previous+current);
      if (stockOut - stockIn != 0) {
        this.stockTransferItemsIn[0].amount += stockOut - stockIn;
        this.setTransferInPrice(this.stockTransferItemsIn[0]);//単価を再計算
      }
    }
  }


  public setTransferOutAmount(item:Common.StockTransferItem){
    var calcUtil:Common.CalcUtil = new Common.CalcUtil;
    item.amount = calcUtil.Round(item.quantity * item.unitPrice, this.astrSystemCurrency.precision, this.astrSystemCurrency.roundType);
    // 仕様を簡素化
    // if(this.astrTransferFlag == Common.TransferTypes.Transfer)
    // {
    //   var temp: Array<Common.StockTransferItem> = new Array(0);
    //   temp = this.stockTransferItemsIn.filter(obj => obj.tempNo == item.tempNo);
    //   if(temp.length > 0)
    //   {
    //     temp[0].amount = item.amount;
    //     this.setTransferInPrice(temp[0]);
    //   }
    // }
    // else if(this.astrTransferFlag == Common.TransferTypes.Assemble)
    // {
    //   this.stockTransferItemsIn[0].amount = this.astrTotalAmountOut;
    //   this.setTransferInPrice( this.stockTransferItemsIn[0])
    // }
    // else if(this.astrTransferFlag == Common.TransferTypes.Divide)
    // {
    //   var totalDivideReferenceAmount: number;
    //   totalDivideReferenceAmount = this.stockTransferItemsIn.map(obj => obj.divideReferenceAmount).reduce((total, value) =>(total + value));
    //   this.stockTransferItemsIn.forEach((obj, index) => {
    //     obj.amount = calcUtil.Round(this.astrTotalAmountOut * obj.divideReferenceAmount / totalDivideReferenceAmount, this.astrSystemCurrency.precision, this.astrSystemCurrency.roundType);
    //   });
    //   // 差分調整(1行目に調整)
    //   var differenceAmount = this.astrTotalAmountOut - this.astrTotalAmountIn;
    //   if(differenceAmount != 0) this.stockTransferItemsIn[0].amount += differenceAmount;

    //   this.stockTransferItemsIn.forEach((obj, index) => {
    //     this.setTransferInPrice(obj);
    //   });
    // }
  }

  public setTransferInPrice(item:Common.StockTransferItem){
    if(item.quantity == 0) item.unitPrice = 0;
    else
    {
      item.unitPrice = item.amount / item.quantity;
      if(item.commodity != null)
      {
        var calcUtil:Common.CalcUtil = new Common.CalcUtil;
        item.unitPrice = calcUtil.Round(item.unitPrice, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
      }
    }
  }

  public setTransferInPriceAll(){
    this.stockTransferItemsIn.forEach((obj, index) => {
      this.setTransferInPrice(obj);
    });
  }

  public setPackage(item:Common.StockTransferItem){
    if(item.commodity == null) item.package = '';
    else item.package = item.commodity.uom;
  }

  public isEditable(inputType:Common.InputTypes,stockType:Common.StockTypes):boolean{
    if(stockType == null) return false;
    if(inputType != Common.InputTypes.None && stockType != Common.StockTypes.None && this.astrTransferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  public isEditableRow():boolean{
    if(this.astrTransferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  public async submitAddStockTransfer(list: Array<Common.StockTransferItem>, index:number){

    // 入力時チェック
    if(this.astrSegmentIn.priceCalculationMethod == Common.PricingTypes.Specific){
      return this.$api.modal.showDialog('','入庫部門に在庫単価計算方法が個別法の部門を指定することはできません。').then(()=>{return false;});;
    }

    if(Moment(this.astrClosingDate).format('YYYYMM') != Moment(this.astrBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>{return false;});;
    }

    if(this.stockTransferItemsOut.filter(item=> item.quantity > 0).length == 0){
      return this.$api.modal.showDialog('', '出庫側の振替数量を入力して下さい。').then(()=>{return false;});
    }

    if(this.stockTransferItemsIn.filter(item=> item.quantity > 0).length == 0){
      return this.$api.modal.showDialog('', '入庫側の振替数量を入力して下さい。').then(()=>{return false;});
    }
    if(this.stockTransferItemsIn.filter(item=> item.amount <= 0).length > 0){
      return this.$api.modal.showDialog('', '入庫金額がゼロ以下にならないように調整して下さい。').then(()=>{return false;});
    }
    if(this.astrSegmentOut.id == this.astrSegmentIn.id && this.astrWarehouseOut.id == this.astrWarehouseIn.id)
    {
      for (var i = 0; i < this.stockTransferItemsOut.length; i++) {
         if(this.stockTransferItemsIn.filter(item=>
            (item.commodity ? item.commodity.id : 0) == this.stockTransferItemsOut[i].commodityId && (item.sku ? item.sku.id :0) == this.stockTransferItemsOut[i].skuId && //in側のcommodityIdとskuIdは更新されていない
            item.reserveText1 == this.stockTransferItemsOut[i].reserveText1 && item.reserveText2 == this.stockTransferItemsOut[i].reserveText2 && item.reserveText3 == this.stockTransferItemsOut[i].reserveText3 &&
            item.reserveText4 == this.stockTransferItemsOut[i].reserveText4 && item.reserveText5 == this.stockTransferItemsOut[i].reserveText5 && item.reserveText6 == this.stockTransferItemsOut[i].reserveText6 &&
            item.reserveMemo1 == this.stockTransferItemsOut[i].reserveMemo1 && item.reserveMemo2 == this.stockTransferItemsOut[i].reserveMemo2 && item.reserveMemo3 == this.stockTransferItemsOut[i].reserveMemo3 &&
            item.reserveDate1 == this.stockTransferItemsOut[i].reserveDate1 && item.reserveDate2 == this.stockTransferItemsOut[i].reserveDate2 && item.reserveDate3 == this.stockTransferItemsOut[i].reserveDate3 &&
            item.reserveList1 == this.stockTransferItemsOut[i].reserveList1 && item.reserveList2 == this.stockTransferItemsOut[i].reserveList2 && item.reserveList3 == this.stockTransferItemsOut[i].reserveList3).length > 0) {
          return this.$api.modal.showDialog('', '出庫側と入庫側で同じ在庫が指定されています。').then(()=>{return false;});
        }
      }
    }

    if(this.astrTotalAmountOut != this.astrTotalAmountIn){
      return this.$api.modal.showDialog('無効な操作', '出庫側と入庫側の合計金額が不一致です。').then(()=>{return false;});
    }

    // クエリ設定
    var query = new Common.CreateStockTransferQuery();
    query.transferFlag = this.astrTransferFlag;
    query.pic = this.astrPic;
    query.bookDate = this.astrBookDate;
    query.refNo = this.astrRefNo;
    query.closingDate = this.astrClosingDate;
    query.segmentOut = this.astrSegmentOut;
    query.segmentIn = this.astrSegmentIn;
    query.warehouseOut = this.astrWarehouseOut;
    query.warehouseIn = this.astrWarehouseIn;
    query.stockTransferItemsOut = this.stockTransferItemsOut;
    query.stockTransferItemsIn = this.stockTransferItemsIn;
    query.workflowId = this.astrWorkflowId;
    query.actionId = this.astrButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockTransfer = this.astrStockTransfer;
    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });
    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.astrUpdatedHandler){
        this.astrUpdatedHandler();
        return true;
      }            
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockTransfer;
      //this.$api.modal.show('処理結果','以下の在庫振替伝票が作成されました。',true,null,[new Common.ModalLink(result.stockTransferNo,String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo))]);
      this.$api.modal.show('処理結果','以下の在庫振替伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo)),[new Common.ModalLink(result.stockTransferNo,String.format('/journal/StockTransfer?stockTransferNo={0}',result.stockTransferNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});
  }

  // 棚卸処理用プロパティ
  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.stock) > 0 ;
  }  
  public astkPic: string = '';
  public astkBookDate: Date = new Date().getCalendarDate();
  public astkRefNo: string = '';
  public astkBarcodeInspection:boolean = false;  
  public astkSegment: Common.Segment = null;
  public astkWarehouse: Common.Counterpart = null;
  public astkClosingDate:Date = new Date().getCalendarDate();
  public astkWorkflowId:number = 0;
  public astkCaptions = new Array();
  public astkWidths = new Array();
  public astkSlots = new Array();
  public astkStockTaking: Common.StockTaking = null;//ポップアップエディタ使用時の親伝票
  public astkUpdatedHandler:()=>void = null; //ポップアップエディタ使用時の完了時のイベントハンドラ  
  // ワークフロー処理用プロパティ
  public astkButtonNames: Array<string> = null;
  public astkButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public astkGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 80),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('庫内数量', 100),
      new Common.GridItemConfiguration('実地棚卸数量', 100),
      new Common.GridItemConfiguration('減耗数量', 100)
    ],
    7, //減耗数量の次を予備項目の挿入位置に指定
    'col'
  );

  @Watch('astkBarcodeInspection')
  public onBarcodeInspectionChanged(){
      this.astkGridConfig.baseConfigurations[4].IsVisible = !this.astkBarcodeInspection;
      this.astkGridConfig.baseConfigurations[5].IsVisible = !this.astkBarcodeInspection;
      this.astkGridConfig.setGridItems();
      this.astkCaptions =this.astkGridConfig.gridCaptions;
      this.astkWidths = this.astkGridConfig.gridWidths;
      this.astkSlots = this.astkGridConfig.gridSlots;      
  }
  // 棚卸処理子画面表示
  public showStockTakingDialog(){
    this.getCheckedStockBalances();

    // ダイアログ表示前バリデーション
    if(!this.stockCommonCheck()) return;

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false);
    this.astkGridConfig.setVariableItems(reserveItems);
    this.astkCaptions =this.astkGridConfig.gridCaptions;
    this.astkWidths = this.astkGridConfig.gridWidths;
    this.astkSlots = this.astkGridConfig.gridSlots;

    // 入力項目の初期化
    if (this.astkStockTaking == null) {
      this.astkPic = this.$api.auth.userId;
      this.astkBookDate = new Date().getCalendarDate();
      this.astkRefNo = '';
      this.astkSegment = this.checkedStockBalances[0].stockKey.segment;
      this.astkWarehouse = this.checkedStockBalances[0].stockKey.warehouse;
      this.astkClosingDate = this.checkedStockBalances[0].closingDate;
      this.astkWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_stockTaking');
    }    
    this.onStockTakingChangeWorkflow();
    // クエリの設定
    var query = new Common.CheckStockTakingQuery();
    query.stockBalances = this.checkedStockBalances;

    // 棚卸処理可能チェック
    this.$api.execute(query).then(res => {
      // ダイアログの表示
      (this.$refs.showStockTakingDialog as Components.ListDialog).items = this.checkedStockBalances;
      (this.$refs.showStockTakingDialog as Components.ListDialog).showDialog();
    });
  }

  public setLossStockQuantity(item: Common.StockBalance){
    // 浮動小数点のフォーマットを行い、小数点以下の桁を指定された桁数までまとめる
    // item.lossStockQuantity = this.$api.formatter.formatNumber((item.stockQuantity - item.physicalStockQuantity), item.stockKey.commodity.quantityScale);
    item.lossStockQuantity = this.calcUtil.Round((item.stockQuantity - item.physicalStockQuantity), item.stockKey.commodity.quantityScale, item.stockKey.commodity.quantityRound)
  }

  public async submitAddStockTaking(list: Array<Common.StockBalance>, index:number){
    // 入力時チェック
    if(Moment(this.astkClosingDate).format('YYYYMM') != Moment(this.astkBookDate).format('YYYYMM')){
      return this.$api.modal.showDialog('', '限月と異なる年月の発生日が入力されています。').then(()=>false);
    }

    // クエリ設定
    var query = new Common.CreateStockTakingQuery();
    query.pic = this.astkPic;
    query.bookDate = this.astkBookDate;
    query.refNo = this.astkRefNo;
    query.barcodeInspection = this.astkBarcodeInspection;
    query.stockBalances = this.checkedStockBalances;
    query.workflowId = this.astkWorkflowId;
    query.actionId = this.astkButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.stockTaking = this.astkStockTaking; //ポップアップエディタを使用した追加モード時の親伝票
    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();
    // });

    return this.$api.execute(query,true).then(res => {
      //ポップアップエディタの場合
      if (this.astkUpdatedHandler){
        this.astkUpdatedHandler();
        return true;
      }      
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var result = res as Common.StockTaking;
      //this.$api.modal.show('処理結果','以下の棚卸処理伝票が作成されました。',true,null,[new Common.ModalLink(result.stockTakingNo,String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo))]);
      this.$api.modal.show('処理結果','以下の棚卸処理伝票が作成されました。',false,()=>this.$router.push(String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo)),[new Common.ModalLink(result.stockTakingNo,String.format('/journal/StockTaking?stockTakingNo={0}',result.stockTakingNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});

  }
  public onStockTakingChangeWorkflow(){
    this.astkButtonNames=new Array();
    this.astkButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.astkButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.astkButtonNames.push("保存");
    if(this.astkWorkflowId!=0 && this.popup == null)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('stockTaking', this.astkWorkflowId, Common.StockTakingStatus.PostWaiting);
      actions.forEach(action => {
        this.astkButtonNames.push(action.actionName);
        this.astkButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

  }



  //諸掛按分処理
  //諸掛按分処理用プロパティ
  public caConfig:Common.GridConfiguration = new Common.GridConfiguration([],0,'col');
  public caPic: string = '';
  public caBookDate: Date = new Date().getCalendarDate();
  public caCurrencyCode: string='';
  public caProportionalDivision: Common.ProportionalDivisionFlags = Common.ProportionalDivisionFlags.ByQuantity;
  public caExchangeRate:number = 0;
  public caRefNo : string = '';
  public caWorkflowId: number = 0;
  public caItems : Common.PurchaseCharge[] = [];
  public caAmountScale : number = 0;
  // ワークフロー処理用プロパティ
  public caButtonNames: Array<string> = null;
  public caButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showChargeAllocationDialog() {
    this.getCheckedStockBalances();

    this.caAmountScale = this.calcUtil.GetSystemCurrencyDecimal(this.$api);
    // ダイアログ表示前バリデーション
    if(this.params.aggregationType != null && this.params.aggregationType != Common.StockBalanceAggregationTypes.None){
      this.$api.modal.show('', '検索条件の「集計」を"集計なし"に変更してから実行してください。', true, null);
      return;
    }
    if(this.checkedStockBalances.length == 0){
      this.$api.modal.show('', '在庫を選択して下さい。', true, null);
      return;
    }
    // if(this.checkedStockBalances.filter(item => item.state != Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted).length > 0){
    //   this.$api.modal.show('', '未処理・入荷待ちの明細は選択できません。', true, null);
    //   return;
    // }
    if(this.checkedStockBalances.filter(item => item.stockKey.segment.id != this.checkedStockBalances[0].stockKey.segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる在庫を、同じ諸掛伝票にまとめることはできません。', true, null);
      return;
    }

    this.caConfig = new Common.GridConfiguration([],0,'col');
    this.caConfig.setGridItems(
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('支払予定日', 150),
    );

    // プロパティの初期化
    this.caPic = this.$api.auth.userId;
    this.caBookDate = new Date().getCalendarDate();
    this.caCurrencyCode = (this.$api.tenantSettings as Common.TenantSettings).currencyCode;
    this.caExchangeRate = 1;

    //ワークフロー初期値のセット
    const workflows = this.$api.formatter.getOptions('workflow_charge');
    if (workflows.length > 0) this.caWorkflowId = workflows[0].value;
    this.onChargeAllocationChangeWorkflow();
    
    // ダイアログの表示
    // var items = this.checkedDeliveryItems.map(item => item.copy());
    this.caItems = new Array();
    this.caItems.push(new Common.PurchaseCharge());
    (this.$refs.chargeAllocationDialog as Components.ListDialog).items = this.caItems;
    (this.$refs.chargeAllocationDialog as Components.ListDialog).showDialog();
  }
  public onChargeAllocationChangeWorkflow(){
    this.caButtonNames=new Array();
    this.caButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.caButtonNames.push("諸掛保存");
    if(this.caWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('charge', this.caWorkflowId, Common.ChargeStatus.ChargeSaving);
      actions.forEach(action => {
        this.caButtonNames.push(action.actionName);
        this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  // 取引先変更時に取引先の税区分・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge){
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    if(item.counterpart == null) item.dueDate = null;
    else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(){
    this.caItems.forEach(item =>{
      if(item.counterpart == null) item.dueDate = null;
      else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
    });
    this.onChangeCurrency();
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(){

    this.caAmountScale = this.calcUtil.GetCurrecyDecimal(this.caCurrencyCode,this.$api);

    const query = new Common.GetExchangeRateQuery();
    query.currency = this.caCurrencyCode;
    query.startDate = this.caBookDate;

    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.caExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });

  }

   public async submitChargeAllocation(list: Array<Common.SalesCharge>, index:number){
    // 選択している入荷伝票の取得
    if (this.caItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','諸掛を入力してください。').then(()=>{return false;});
    }

    if (this.checkedStockBalances.filter(obj =>obj.closingDate.getBeginDate() > this.caBookDate).length > 0){ //月初日と比較
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','限月よりも前の発生日が入力されています。').then(()=>{return false;});
    }

    //ヘッダプロパティの設定
    this.caItems.forEach(charge =>{
      charge.currencyCode = this.caCurrencyCode;
      charge.exchangeRate = this.caExchangeRate;
      charge.proportionalDivision = this.caProportionalDivision;
      charge.workflowId = this.caWorkflowId;
      charge.chargeDate = this.caBookDate;
      charge.pic = this.caPic;
      charge.refNo = this.caRefNo;
      charge.chargeFlag = Common.SalesPurchaseFlags.Purchase; //仕入諸掛
      charge.segment = this.checkedStockBalances[0].stockKey.segment;
      charge.target = Common.ChargeItemTypes.Stock;
    });

    // クエリの設定
    var query = new Common.AddStockChargeAllocationQuery();
    query.charges = this.caItems; //諸掛のセット
    query.stockBalances = this.checkedStockBalances; //按分対象のセット
    query.actionId = this.caButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    // 諸掛按分明細追加の実行
    return this.$api.execute(query,true).then(res => {
      //ダイアログ表示
      var charges = res as Common.PurchaseCharge[];
      var links = charges.map(charge=>new Common.ModalLink(charge.chargeNo,String.format('/purchase/PurchaseCharge?chargeNo={0}',charge.chargeNo)));
      // this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',false,()=>this.$router.push(String.format('/purchase/PurchaseCharge?chargeNo={0}',charges[0].chargeNo)),links,'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});
   }
}
</script>

<style lang="scss">
  .stock_transfer{
    .modal-dialog {
      width: fit-content !important;
      min-width: 400px;
      max-width: 90% !important;

      .cx_spmode & {
        max-width:unset !important;
      }
    }
    .header_cell {
      // border-left: none !important;
      // border-right: none !important;
    }
  }
  .cx_label{
    font-size:12px;
  }
  .cx_stock_dialog{
    table {
      .cx_numric_box{
        div{
          text-align: right;
        }
      }
    }
  }
</style>